import { createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, createElementVNode as _createElementVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementBlock as _createElementBlock, mergeProps as _mergeProps, resolveDirective as _resolveDirective, withDirectives as _withDirectives, normalizeProps as _normalizeProps, guardReactiveProps as _guardReactiveProps, toDisplayString as _toDisplayString } from "vue"

const _hoisted_1 = {
  key: 0,
  class: "pl-0 pr-1 py-0 ma-0"
}
const _hoisted_2 = { class: "pl-0 pr-1 py-0 ma-0" }
const _hoisted_3 = { class: "pl-0 pr-1 py-0 ma-0" }
const _hoisted_4 = { class: "pl-0 pr-1 py-0 ma-0" }
const _hoisted_5 = {
  cols: "1",
  class: "pl-4 ma-0"
}
const _hoisted_6 = ["colspan"]
const _hoisted_7 = { class: "d-flex justify-end mr-8" }
const _hoisted_8 = {
  key: 0,
  class: "pl-0 pr-1 py-0 ma-0"
}
const _hoisted_9 = { class: "pl-0 pr-1 py-0 ma-0" }
const _hoisted_10 = { class: "pl-0 pr-1 py-0 ma-0" }
const _hoisted_11 = { class: "pl-0 pr-1 py-0 ma-0" }
const _hoisted_12 = { class: "pl-4 ma-0" }
const _hoisted_13 = ["colspan"]
const _hoisted_14 = { class: "d-flex justify-end mr-8" }
const _hoisted_15 = {
  key: 0,
  class: "pl-0 pr-1 py-0 ma-0"
}
const _hoisted_16 = {
  class: "py-0 pl-0 pr-2 ma-0",
  colspan: 2
}
const _hoisted_17 = { class: "py-0 pl-0 pr-2 ma-0" }
const _hoisted_18 = { class: "py-0 pl-0 pr-2 ma-0" }
const _hoisted_19 = { class: "py-0 pl-0 pr-2 ma-0" }
const _hoisted_20 = { class: "py-0 pl-0 pr-2 ma-0" }
const _hoisted_21 = { class: "py-0 pl-0 pr-2 ma-0" }
const _hoisted_22 = { class: "py-0 pl-0 pr-2 ma-0" }
const _hoisted_23 = { class: "py-0 pl-0 pr-2 ma-0" }
const _hoisted_24 = { class: "py-0 pl-0 pr-2 ma-0" }
const _hoisted_25 = { class: "pl-2 ma-0" }
const _hoisted_26 = ["colspan"]
const _hoisted_27 = { class: "d-flex justify-end mr-2" }
const _hoisted_28 = {
  key: 0,
  class: "pl-0 pr-1 py-0 ma-0"
}
const _hoisted_29 = { class: "pl-0 pr-1 py-0 ma-0" }
const _hoisted_30 = { class: "pl-0 pr-1 py-0 ma-0" }
const _hoisted_31 = { class: "pl-0 pr-1 py-0 ma-0" }
const _hoisted_32 = { class: "pl-0 pr-1 py-0 ma-0" }
const _hoisted_33 = { class: "pl-0 pr-1 py-0 ma-0" }
const _hoisted_34 = { class: "pl-3 ma-0" }
const _hoisted_35 = ["colspan"]
const _hoisted_36 = { class: "d-flex justify-end mr-3" }
const _hoisted_37 = {
  key: 0,
  class: "pl-0 pr-1 py-0 ma-0"
}
const _hoisted_38 = {
  class: "pl-0 pr-1 py-0 ma-0",
  colspan: 2
}
const _hoisted_39 = {
  key: 1,
  class: "pl-0 pr-1 py-0 ma-0"
}
const _hoisted_40 = { class: "pl-2 pr-0 py-0 ma-0" }
const _hoisted_41 = { class: "pl-0 pr-1 py-0 ma-0" }
const _hoisted_42 = { class: "pl-0 pr-1 py-0 ma-0" }
const _hoisted_43 = { class: "pl-0 pr-1 py-0 ma-0" }
const _hoisted_44 = {
  key: 2,
  class: "pl-0 pr-1 py-0 ma-0"
}
const _hoisted_45 = {
  key: 3,
  class: "pl-0 pr-1 py-0 ma-0"
}
const _hoisted_46 = {
  key: 4,
  class: "pl-0 pr-1 py-0 ma-0"
}
const _hoisted_47 = {
  key: 5,
  class: "pl-0 pr-1 py-0 ma-0"
}
const _hoisted_48 = {
  key: 6,
  class: "pl-0 pr-1 py-0 ma-0"
}
const _hoisted_49 = {
  key: 7,
  class: "pl-0 pr-1 py-0 ma-0"
}
const _hoisted_50 = {
  key: 8,
  class: "pl-0 pr-1 py-0 ma-0"
}
const _hoisted_51 = {
  key: 9,
  class: "pl-0 pr-1 py-0 ma-0"
}
const _hoisted_52 = { class: "pl-0 pr-1 py-0 ma-0" }
const _hoisted_53 = { class: "pl-0 pr-1 py-0 ma-0" }
const _hoisted_54 = { class: "pl-0 pr-1 py-0 ma-0" }
const _hoisted_55 = { class: "pl-0 pr-1 py-0 ma-0" }
const _hoisted_56 = { class: "pl-2 pr-0 py-0 ma-0" }
const _hoisted_57 = { class: "pl-0 ma-0" }
const _hoisted_58 = ["colspan"]
const _hoisted_59 = ["colspan"]
const _hoisted_60 = { class: "d-flex justify-end mr-2" }
const _hoisted_61 = {
  key: 0,
  class: "pl-0 pr-1 py-0 ma-0"
}
const _hoisted_62 = {
  class: "pl-0 pr-1 py-0 ma-0",
  colspan: 2
}
const _hoisted_63 = { class: "pl-2 pr-0 py-0 ma-0" }
const _hoisted_64 = { class: "pl-0 pr-1 py-0 ma-0" }
const _hoisted_65 = { class: "pl-0 pr-1 py-0 ma-0" }
const _hoisted_66 = { class: "pl-0 pr-1 py-0 ma-0" }
const _hoisted_67 = {
  key: 1,
  class: "pl-0 pr-1 py-0 ma-0"
}
const _hoisted_68 = {
  key: 2,
  class: "pl-0 pr-1 py-0 ma-0"
}
const _hoisted_69 = {
  key: 3,
  class: "pl-0 pr-1 py-0 ma-0"
}
const _hoisted_70 = {
  key: 4,
  class: "pl-0 pr-1 py-0 ma-0"
}
const _hoisted_71 = {
  key: 5,
  class: "pl-0 pr-1 py-0 ma-0"
}
const _hoisted_72 = {
  key: 6,
  class: "pl-0 pr-1 py-0 ma-0"
}
const _hoisted_73 = {
  key: 7,
  class: "pl-0 pr-1 py-0 ma-0"
}
const _hoisted_74 = {
  key: 8,
  class: "pl-0 pr-1 py-0 ma-0"
}
const _hoisted_75 = { class: "py-0 pl-0 pr-2 ma-0" }
const _hoisted_76 = { class: "py-0 pl-0 pr-2 ma-0" }
const _hoisted_77 = { class: "pl-0 pr-1 py-0 ma-0" }
const _hoisted_78 = { class: "pl-0 pr-1 py-0 ma-0" }
const _hoisted_79 = { class: "pl-2 pr-0 py-0 ma-0" }
const _hoisted_80 = { class: "pl-0 ma-0" }
const _hoisted_81 = ["colspan"]
const _hoisted_82 = ["colspan"]
const _hoisted_83 = { class: "d-flex justify-end mr-2" }
const _hoisted_84 = {
  class: "pa-0 ma-0",
  height: "50"
}
const _hoisted_85 = {
  key: 0,
  class: "pl-0 pr-1 py-0 ma-0"
}
const _hoisted_86 = {
  class: "pl-0 pr-1 py-0 ma-0",
  colspan: 2
}
const _hoisted_87 = { class: "pl-0 pr-1 py-0 ma-0" }
const _hoisted_88 = { class: "pl-0 pr-1 py-0 ma-0" }
const _hoisted_89 = { class: "pl-0 pr-1 py-0 ma-0" }
const _hoisted_90 = { class: "pl-0 pr-1 py-0 ma-0" }
const _hoisted_91 = { class: "pl-0 pr-1 py-0 ma-0" }
const _hoisted_92 = { class: "pl-0 pr-1 py-0 ma-0" }
const _hoisted_93 = { class: "pl-0 pr-0 py-0 ma-0" }
const _hoisted_94 = { class: "pl-2 ma-0" }
const _hoisted_95 = ["colspan"]
const _hoisted_96 = { class: "d-flex justify-end mt-1 mr-2" }
const _hoisted_97 = {
  key: 0,
  class: "pl-0 pr-1 py-0 ma-0"
}
const _hoisted_98 = { class: "pl-2 pr-0 py-0 ma-0" }
const _hoisted_99 = {
  class: "pl-0 pr-1 py-0 ma-0",
  colspan: 2
}
const _hoisted_100 = { class: "pl-0 pr-1 py-0 ma-0" }
const _hoisted_101 = { class: "pl-0 pr-1 py-0 ma-0" }
const _hoisted_102 = { class: "pl-0 pr-1 py-0 ma-0" }
const _hoisted_103 = {
  key: 1,
  class: "pl-0 pr-1 py-0 ma-0"
}
const _hoisted_104 = {
  key: 2,
  class: "pl-0 pr-1 py-0 ma-0"
}
const _hoisted_105 = {
  key: 3,
  class: "pl-0 pr-1 py-0 ma-0"
}
const _hoisted_106 = {
  key: 4,
  class: "pl-0 pr-1 py-0 ma-0"
}
const _hoisted_107 = { class: "pl-2 pr-0 py-0 ma-0" }
const _hoisted_108 = { class: "pl-2 ma-0" }
const _hoisted_109 = ["colspan"]
const _hoisted_110 = ["colspan"]
const _hoisted_111 = { class: "d-flex justify-end mr-2" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_v_btn = _resolveComponent("v-btn")!
  const _component_v_tab = _resolveComponent("v-tab")!
  const _component_v_tabs = _resolveComponent("v-tabs")!
  const _component_v_expansion_panel_title = _resolveComponent("v-expansion-panel-title")!
  const _component_v_combobox_filled = _resolveComponent("v-combobox-filled")!
  const _component_v_text_field_filled = _resolveComponent("v-text-field-filled")!
  const _component_oss_date_picker_filled = _resolveComponent("oss-date-picker-filled")!
  const _component_oss_text_field_filled = _resolveComponent("oss-text-field-filled")!
  const _component_v_icon = _resolveComponent("v-icon")!
  const _component_v_tooltip = _resolveComponent("v-tooltip")!
  const _component_v_data_table = _resolveComponent("v-data-table")!
  const _component_v_expansion_panel_text = _resolveComponent("v-expansion-panel-text")!
  const _component_v_expansion_panel = _resolveComponent("v-expansion-panel")!
  const _component_v_select_filled = _resolveComponent("v-select-filled")!
  const _component_v_expansion_panels = _resolveComponent("v-expansion-panels")!
  const _component_v_card_text = _resolveComponent("v-card-text")!
  const _component_v_btn_prev = _resolveComponent("v-btn-prev")!
  const _component_v_btn_next = _resolveComponent("v-btn-next")!
  const _component_v_card_actions = _resolveComponent("v-card-actions")!
  const _component_v_card = _resolveComponent("v-card")!
  const _component_v_window_item = _resolveComponent("v-window-item")!
  const _component_v_checkbox = _resolveComponent("v-checkbox")!
  const _component_ActivityDetails = _resolveComponent("ActivityDetails")!
  const _component_ChargeDetails = _resolveComponent("ChargeDetails")!
  const _component_v_col = _resolveComponent("v-col")!
  const _component_v_row = _resolveComponent("v-row")!
  const _component_v_menu = _resolveComponent("v-menu")!
  const _component_StaffDetails = _resolveComponent("StaffDetails")!
  const _component_v_tabs_window = _resolveComponent("v-tabs-window")!
  const _component_v_snackbar = _resolveComponent("v-snackbar")!
  const _component_v_card_title = _resolveComponent("v-card-title")!
  const _component_v_list_item_title = _resolveComponent("v-list-item-title")!
  const _component_v_list_item_subtitle = _resolveComponent("v-list-item-subtitle")!
  const _component_v_list_item = _resolveComponent("v-list-item")!
  const _component_v_list = _resolveComponent("v-list")!
  const _component_v_window = _resolveComponent("v-window")!
  const _component_oss_dialog = _resolveComponent("oss-dialog")!
  const _component_v_form = _resolveComponent("v-form")!
  const _directive_tooltip = _resolveDirective("tooltip")!

  return (_openBlock(), _createBlock(_component_v_form, {
    modelValue: _ctx.validForm,
    "onUpdate:modelValue": _cache[39] || (_cache[39] = ($event: any) => ((_ctx.validForm) = $event)),
    "lazy-validation": ""
  }, {
    default: _withCtx(() => [
      _createVNode(_component_v_card, {
        style: {"background-color":"transparent"},
        class: "elevation-0 mx-0"
      }, {
        default: _withCtx(() => [
          _createElementVNode("div", null, [
            _createVNode(_component_v_tabs, {
              modelValue: _ctx.step,
              "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.step) = $event)),
              "fixed-tabs": ""
            }, {
              default: _withCtx(() => [
                _createVNode(_component_v_tab, {
                  value: "1",
                  href: "#1",
                  style: {"justify-content":"left"}
                }, {
                  default: _withCtx(() => [
                    _createVNode(_component_v_btn, {
                      color: _ctx.step === '1' ? 'primary' : '_grey',
                      "data-cy": "BudgetFormFull-finance",
                      size: "x-small",
                      class: "pr-2"
                    }, {
                      default: _withCtx(() => _cache[40] || (_cache[40] = [
                        _createTextVNode(" 1 ")
                      ])),
                      _: 1
                    }, 8, ["color"]),
                    _cache[41] || (_cache[41] = _createElementVNode("div", { class: "d-flex align-center justify-center pl-4" }, "Financement", -1))
                  ]),
                  _: 1
                }),
                _createVNode(_component_v_tab, {
                  value: "2",
                  href: "#2",
                  style: {"justify-content":"left"}
                }, {
                  default: _withCtx(() => [
                    _createVNode(_component_v_btn, {
                      color: _ctx.step === '2' ? 'primary' : '_grey',
                      "data-cy": "BudgetFormFull-activity",
                      size: "x-small",
                      class: "pr-2"
                    }, {
                      default: _withCtx(() => _cache[42] || (_cache[42] = [
                        _createTextVNode(" 2 ")
                      ])),
                      _: 1
                    }, 8, ["color"]),
                    _cache[43] || (_cache[43] = _createElementVNode("div", { class: "d-flex align-center justify-center pl-4" }, "Activité", -1))
                  ]),
                  _: 1
                }),
                _createVNode(_component_v_tab, {
                  value: "3",
                  href: "#3",
                  style: {"justify-content":"left"}
                }, {
                  default: _withCtx(() => [
                    _createVNode(_component_v_btn, {
                      color: _ctx.step === '3' ? 'primary' : '_grey',
                      "data-cy": "BudgetFormFull-fillers",
                      size: "x-small",
                      class: "pr-2"
                    }, {
                      default: _withCtx(() => _cache[44] || (_cache[44] = [
                        _createTextVNode(" 3 ")
                      ])),
                      _: 1
                    }, 8, ["color"]),
                    _cache[45] || (_cache[45] = _createElementVNode("div", { class: "d-flex align-center justify-center pl-4" }, "Charges", -1))
                  ]),
                  _: 1
                }),
                _createVNode(_component_v_tab, {
                  value: "4",
                  href: "#4",
                  style: {"justify-content":"left"}
                }, {
                  default: _withCtx(() => [
                    _createVNode(_component_v_btn, {
                      color: _ctx.step === '4' ? 'primary' : '_grey',
                      "data-cy": "BudgetFormFull-staff",
                      size: "x-small",
                      class: "pr-4"
                    }, {
                      default: _withCtx(() => _cache[46] || (_cache[46] = [
                        _createTextVNode(" 4 ")
                      ])),
                      _: 1
                    }, 8, ["color"]),
                    _cache[47] || (_cache[47] = _createElementVNode("div", { class: "d-flex align-center justify-center pl-4" }, "Personnel", -1))
                  ]),
                  _: 1
                })
              ]),
              _: 1
            }, 8, ["modelValue"]),
            _createVNode(_component_v_tabs_window, {
              modelValue: _ctx.step,
              "onUpdate:modelValue": _cache[25] || (_cache[25] = ($event: any) => ((_ctx.step) = $event))
            }, {
              default: _withCtx(() => [
                _createVNode(_component_v_window_item, { value: "1" }, {
                  default: _withCtx(() => [
                    _createVNode(_component_v_card, { style: {"box-shadow":"none"} }, {
                      default: _withCtx(() => [
                        _createVNode(_component_v_card_text, null, {
                          default: _withCtx(() => [
                            _createVNode(_component_v_expansion_panels, {
                              modelValue: _ctx.fundingsExpanded,
                              "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => ((_ctx.fundingsExpanded) = $event)),
                              multiple: "",
                              accordion: "",
                              style: {"box-shadow":"none"}
                            }, {
                              default: _withCtx(() => [
                                _createVNode(_component_v_expansion_panel, { class: "py-0 my-0" }, {
                                  default: _withCtx(() => [
                                    _createVNode(_component_v_expansion_panel_title, { class: "py-0 my-0" }, {
                                      default: _withCtx(() => _cache[48] || (_cache[48] = [
                                        _createElementVNode("h3", null, "Apports en capital", -1)
                                      ])),
                                      _: 1
                                    }),
                                    _createVNode(_component_v_expansion_panel_text, { class: "py-0 my-0" }, {
                                      default: _withCtx(() => [
                                        _createVNode(_component_v_data_table, {
                                          items: _ctx.formBff.fundings.capitalContributions,
                                          headers: _ctx.capitalContributionsHeaders,
                                          itemsPerPage: 
                                                    _ctx.formBff.fundings.capitalContributions.length
                                                ,
                                          "hide-default-footer": "",
                                          class: "table"
                                        }, {
                                          item: _withCtx((props) => [
                                            _createElementVNode("tr", null, [
                                              (_ctx.selectedPartition)
                                                ? (_openBlock(), _createElementBlock("td", _hoisted_1, [
                                                    (_ctx.selectedPartition)
                                                      ? (_openBlock(), _createBlock(_component_v_combobox_filled, {
                                                          key: 0,
                                                          modelValue: props.item.tag,
                                                          "onUpdate:modelValue": ($event: any) => ((props.item.tag) = $event),
                                                          items: _ctx.tagsSelection,
                                                          "item-value": "id",
                                                          dense: "",
                                                          "hide-details": "auto",
                                                          onChange: ($event: any) => (
                                                                    _ctx.updateTagsSelection(props.item)
                                                                ),
                                                          "item-title": (item) => item.name
                                                        }, null, 8, ["modelValue", "onUpdate:modelValue", "items", "onChange", "item-title"]))
                                                      : _createCommentVNode("", true)
                                                  ]))
                                                : _createCommentVNode("", true),
                                              _createElementVNode("td", _hoisted_2, [
                                                _createVNode(_component_v_text_field_filled, {
                                                  modelValue: props.item.title,
                                                  "onUpdate:modelValue": ($event: any) => ((props.item.title) = $event),
                                                  "hide-details": "auto",
                                                  density: "compact"
                                                }, null, 8, ["modelValue", "onUpdate:modelValue"])
                                              ]),
                                              _createElementVNode("td", _hoisted_3, [
                                                _createVNode(_component_oss_date_picker_filled, {
                                                  "model-value": 
                                                                    _ctx.transformGapToDate(
                                                                        props.item.monthGap,
                                                                    )
                                                                ,
                                                  type: "month",
                                                  format: "MM-YYYY",
                                                  "text-field-readonly": false,
                                                  "hide-details": "auto",
                                                  onChangeDate: _ctx.assignItemDate,
                                                  onClose: ($event: any) => (
                                                                    _ctx.transformDateToGap(props.item)
                                                                )
                                                }, null, 8, ["model-value", "onChangeDate", "onClose"])
                                              ]),
                                              _createElementVNode("td", _hoisted_4, [
                                                _createVNode(_component_oss_text_field_filled, {
                                                  "hide-details": "auto",
                                                  modelValue: props.item.amount,
                                                  "onUpdate:modelValue": ($event: any) => ((props.item.amount) = $event)
                                                }, null, 8, ["modelValue", "onUpdate:modelValue"])
                                              ]),
                                              _createElementVNode("td", _hoisted_5, [
                                                _createVNode(_component_v_tooltip, { location: "bottom" }, {
                                                  activator: _withCtx(({ props }) => [
                                                    _createVNode(_component_v_icon, _mergeProps({
                                                      onClick: ($event: any) => {
                                                                            _ctx.activeItemType =
                                                                                'capitalContribution';
                                                                            _ctx.deleteLine(props.index);
                                                                        }
                                                    }, props), {
                                                      default: _withCtx(() => _cache[49] || (_cache[49] = [
                                                        _createTextVNode("$oss-trash")
                                                      ])),
                                                      _: 2
                                                    }, 1040, ["onClick"])
                                                  ]),
                                                  default: _withCtx(() => [
                                                    _cache[50] || (_cache[50] = _createElementVNode("span", null, "Supprimer la ligne", -1))
                                                  ]),
                                                  _: 2
                                                }, 1024),
                                                _createVNode(_component_v_tooltip, { location: "bottom" }, {
                                                  activator: _withCtx(({ props }) => [
                                                    _createVNode(_component_v_icon, _mergeProps({
                                                      onClick: ($event: any) => (
                                                                            _ctx.reinitializeLine(
                                                                                props.index,
                                                                            )
                                                                        )
                                                    }, props), {
                                                      default: _withCtx(() => _cache[51] || (_cache[51] = [
                                                        _createTextVNode("$oss-file")
                                                      ])),
                                                      _: 2
                                                    }, 1040, ["onClick"])
                                                  ]),
                                                  default: _withCtx(() => [
                                                    _cache[52] || (_cache[52] = _createElementVNode("span", null, "Réinitialiser la ligne", -1))
                                                  ]),
                                                  _: 2
                                                }, 1024)
                                              ])
                                            ])
                                          ]),
                                          [`body.append`]: _withCtx(({ columns }) => [
                                            _createElementVNode("tr", null, [
                                              _createElementVNode("td", {
                                                colspan: columns.length
                                              }, [
                                                _createElementVNode("div", _hoisted_7, [
                                                  _createVNode(_component_v_btn, {
                                                    rounded: "",
                                                    elevation: "0",
                                                    onClick: _cache[1] || (_cache[1] = ($event: any) => (
                                                                        _ctx.addCapitalContribution()
                                                                    )),
                                                    size: "small"
                                                  }, {
                                                    default: _withCtx(() => _cache[53] || (_cache[53] = [
                                                      _createTextVNode(" Ajouter une ligne ")
                                                    ])),
                                                    _: 1
                                                  })
                                                ])
                                              ], 8, _hoisted_6)
                                            ])
                                          ]),
                                          _: 2
                                        }, 1032, ["items", "headers", "itemsPerPage"])
                                      ]),
                                      _: 1
                                    })
                                  ]),
                                  _: 1
                                }),
                                _createVNode(_component_v_expansion_panel, { class: "py-0 my-0" }, {
                                  default: _withCtx(() => [
                                    _createVNode(_component_v_expansion_panel_title, { class: "py-0 my-0" }, {
                                      default: _withCtx(() => _cache[54] || (_cache[54] = [
                                        _createElementVNode("h3", null, "Apports en comptes courants", -1)
                                      ])),
                                      _: 1
                                    }),
                                    _createVNode(_component_v_expansion_panel_text, { class: "py-0 my-0" }, {
                                      default: _withCtx(() => [
                                        _createVNode(_component_v_data_table, {
                                          items: 
                                                    _ctx.formBff.fundings.currentAccountContributions
                                                ,
                                          headers: _ctx.currentAccountContributionsHeaders,
                                          itemsPerPage: 
                                                    _ctx.formBff.fundings.currentAccountContributions
                                                        .length
                                                ,
                                          "hide-default-footer": "",
                                          class: "table"
                                        }, {
                                          item: _withCtx((props) => [
                                            _createElementVNode("tr", null, [
                                              (_ctx.selectedPartition)
                                                ? (_openBlock(), _createElementBlock("td", _hoisted_8, [
                                                    _createVNode(_component_v_combobox_filled, {
                                                      modelValue: props.item.tag,
                                                      "onUpdate:modelValue": ($event: any) => ((props.item.tag) = $event),
                                                      items: _ctx.tagsSelection,
                                                      "item-value": "id",
                                                      dense: "",
                                                      "hide-details": "auto",
                                                      onChange: ($event: any) => (
                                                                    _ctx.updateTagsSelection(props.item)
                                                                ),
                                                      "item-title": (item) => item.name
                                                    }, null, 8, ["modelValue", "onUpdate:modelValue", "items", "onChange", "item-title"])
                                                  ]))
                                                : _createCommentVNode("", true),
                                              _createElementVNode("td", _hoisted_9, [
                                                _createVNode(_component_v_text_field_filled, {
                                                  modelValue: props.item.name,
                                                  "onUpdate:modelValue": ($event: any) => ((props.item.name) = $event),
                                                  "hide-details": "auto",
                                                  density: "compact"
                                                }, null, 8, ["modelValue", "onUpdate:modelValue"])
                                              ]),
                                              _createElementVNode("td", _hoisted_10, [
                                                _createVNode(_component_oss_date_picker_filled, {
                                                  date: 
                                                                    _ctx.transformGapToDate(
                                                                        props.item.monthGap,
                                                                    )
                                                                ,
                                                  onChangeDate: _ctx.assignItemDate,
                                                  onClose: ($event: any) => (
                                                                    _ctx.transformDateToGap(props.item)
                                                                ),
                                                  type: "month",
                                                  format: "MM-YYYY",
                                                  "text-field-readonly": false,
                                                  "hide-details": "auto"
                                                }, null, 8, ["date", "onChangeDate", "onClose"])
                                              ]),
                                              _createElementVNode("td", _hoisted_11, [
                                                _createVNode(_component_oss_text_field_filled, {
                                                  "hide-details": "auto",
                                                  modelValue: props.item.amount,
                                                  "onUpdate:modelValue": ($event: any) => ((props.item.amount) = $event)
                                                }, null, 8, ["modelValue", "onUpdate:modelValue"])
                                              ]),
                                              _createElementVNode("td", _hoisted_12, [
                                                _createVNode(_component_v_tooltip, { location: "bottom" }, {
                                                  activator: _withCtx(({ props }) => [
                                                    _createVNode(_component_v_icon, _mergeProps({
                                                      onClick: ($event: any) => {
                                                                            _ctx.activeItemType =
                                                                                'currentAccountContribution';
                                                                            _ctx.deleteLine(props.index);
                                                                        }
                                                    }, props), {
                                                      default: _withCtx(() => _cache[55] || (_cache[55] = [
                                                        _createTextVNode("$oss-trash")
                                                      ])),
                                                      _: 2
                                                    }, 1040, ["onClick"])
                                                  ]),
                                                  default: _withCtx(() => [
                                                    _cache[56] || (_cache[56] = _createElementVNode("span", null, "Supprimer la ligne", -1))
                                                  ]),
                                                  _: 2
                                                }, 1024),
                                                _createVNode(_component_v_tooltip, { location: "bottom" }, {
                                                  activator: _withCtx(({ props }) => [
                                                    _createVNode(_component_v_icon, _mergeProps({
                                                      onClick: ($event: any) => (
                                                                            _ctx.reinitializeLine(
                                                                                props.index,
                                                                            )
                                                                        )
                                                    }, props), {
                                                      default: _withCtx(() => _cache[57] || (_cache[57] = [
                                                        _createTextVNode("$oss-file")
                                                      ])),
                                                      _: 2
                                                    }, 1040, ["onClick"])
                                                  ]),
                                                  default: _withCtx(() => [
                                                    _cache[58] || (_cache[58] = _createElementVNode("span", null, "Réinitialiser la ligne", -1))
                                                  ]),
                                                  _: 2
                                                }, 1024)
                                              ])
                                            ])
                                          ]),
                                          [`body.append`]: _withCtx(({ columns }) => [
                                            _createElementVNode("tr", null, [
                                              _createElementVNode("td", {
                                                colspan: columns.length
                                              }, [
                                                _createElementVNode("div", _hoisted_14, [
                                                  _createVNode(_component_v_btn, {
                                                    rounded: "",
                                                    elevation: "0",
                                                    onClick: _cache[2] || (_cache[2] = ($event: any) => (
                                                                        _ctx.addCurrentAccountContribution()
                                                                    )),
                                                    size: "small"
                                                  }, {
                                                    default: _withCtx(() => _cache[59] || (_cache[59] = [
                                                      _createTextVNode(" Ajouter une ligne ")
                                                    ])),
                                                    _: 1
                                                  })
                                                ])
                                              ], 8, _hoisted_13)
                                            ])
                                          ]),
                                          _: 2
                                        }, 1032, ["items", "headers", "itemsPerPage"])
                                      ]),
                                      _: 1
                                    })
                                  ]),
                                  _: 1
                                }),
                                _createVNode(_component_v_expansion_panel, { class: "py-0 my-0" }, {
                                  default: _withCtx(() => [
                                    _createVNode(_component_v_expansion_panel_title, { class: "py-0 my-0" }, {
                                      default: _withCtx(() => _cache[60] || (_cache[60] = [
                                        _createElementVNode("h3", null, "Emprunts", -1)
                                      ])),
                                      _: 1
                                    }),
                                    _createVNode(_component_v_expansion_panel_text, { class: "py-0 my-0" }, {
                                      default: _withCtx(() => [
                                        _createVNode(_component_v_data_table, {
                                          items: _ctx.formBff.fundings.loans,
                                          headers: _ctx.loansHeaders,
                                          itemPerPage: _ctx.formBff.fundings.loans.length,
                                          "hide-default-footer": "",
                                          class: "table"
                                        }, {
                                          item: _withCtx((props) => [
                                            _createElementVNode("tr", null, [
                                              (_ctx.selectedPartition)
                                                ? (_openBlock(), _createElementBlock("td", _hoisted_15, [
                                                    _createVNode(_component_v_combobox_filled, {
                                                      modelValue: props.item.tag,
                                                      "onUpdate:modelValue": ($event: any) => ((props.item.tag) = $event),
                                                      items: _ctx.tagsSelection,
                                                      "item-value": "id",
                                                      dense: "",
                                                      "hide-details": "auto",
                                                      onChange: ($event: any) => (
                                                                    _ctx.updateTagsSelection(props.item)
                                                                ),
                                                      "item-title": (item) => item.name
                                                    }, null, 8, ["modelValue", "onUpdate:modelValue", "items", "onChange", "item-title"])
                                                  ]))
                                                : _createCommentVNode("", true),
                                              _createElementVNode("td", _hoisted_16, [
                                                _createVNode(_component_v_text_field_filled, {
                                                  modelValue: props.item.title,
                                                  "onUpdate:modelValue": ($event: any) => ((props.item.title) = $event),
                                                  "hide-details": "auto",
                                                  density: "compact"
                                                }, null, 8, ["modelValue", "onUpdate:modelValue"])
                                              ]),
                                              _createElementVNode("td", _hoisted_17, [
                                                _createVNode(_component_oss_date_picker_filled, _mergeProps({
                                                  date: 
                                                                    _ctx.transformGapToDate(
                                                                        props.item.monthGap,
                                                                    )
                                                                
                                                }, props, {
                                                  onChangeDate: _ctx.assignItemDate,
                                                  onClose: ($event: any) => (
                                                                    _ctx.transformDateToGap(props.item)
                                                                ),
                                                  type: "month",
                                                  format: "MM-YYYY",
                                                  "text-field-readonly": false,
                                                  "hide-details": "auto",
                                                  onChange: ($event: any) => (
                                                                    _ctx.computeLoanAmounts(props.item)
                                                                )
                                                }), null, 16, ["date", "onChangeDate", "onClose", "onChange"])
                                              ]),
                                              _createElementVNode("td", _hoisted_18, [
                                                _createVNode(_component_oss_text_field_filled, {
                                                  "hide-details": "auto",
                                                  onChange: ($event: any) => (
                                                                    _ctx.computeLoanAmounts(props.item)
                                                                ),
                                                  modelValue: props.item.amount,
                                                  "onUpdate:modelValue": ($event: any) => ((props.item.amount) = $event)
                                                }, null, 8, ["onChange", "modelValue", "onUpdate:modelValue"])
                                              ]),
                                              _createElementVNode("td", _hoisted_19, [
                                                _createVNode(_component_oss_text_field_filled, {
                                                  "hide-details": "auto",
                                                  onChange: ($event: any) => (
                                                                    _ctx.computeLoanAmounts(props.item)
                                                                ),
                                                  modelValue: props.item.rate,
                                                  "onUpdate:modelValue": ($event: any) => ((props.item.rate) = $event)
                                                }, null, 8, ["onChange", "modelValue", "onUpdate:modelValue"])
                                              ]),
                                              _createElementVNode("td", _hoisted_20, [
                                                _createVNode(_component_v_select_filled, {
                                                  modelValue: props.item.duration,
                                                  "onUpdate:modelValue": [($event: any) => ((props.item.duration) = $event), ($event: any) => (
                                                                    _ctx.computeLoanAmounts(props.item)
                                                                )],
                                                  items: _ctx.durationDelays,
                                                  "item-value": "id",
                                                  required: "",
                                                  "hide-details": "auto",
                                                  density: "compact",
                                                  "item-title": (item) => item.name
                                                }, null, 8, ["modelValue", "onUpdate:modelValue", "items", "item-title"])
                                              ]),
                                              _createElementVNode("td", _hoisted_21, [
                                                _createVNode(_component_v_select_filled, {
                                                  modelValue: props.item.periodicity,
                                                  "onUpdate:modelValue": [($event: any) => ((props.item.periodicity) = $event), ($event: any) => (
                                                                    _ctx.computeLoanAmounts(props.item)
                                                                )],
                                                  items: _ctx.loanPeriodicity,
                                                  "item-value": "id",
                                                  required: "",
                                                  "hide-details": "auto",
                                                  density: "compact",
                                                  "item-title": (item) => item.name
                                                }, null, 8, ["modelValue", "onUpdate:modelValue", "items", "item-title"])
                                              ]),
                                              _createElementVNode("td", _hoisted_22, [
                                                _createVNode(_component_oss_text_field_filled, {
                                                  "hide-details": "auto",
                                                  onChange: ($event: any) => (
                                                                    _ctx.computeLoanAmounts(props.item)
                                                                ),
                                                  modelValue: props.item.insuranceRate,
                                                  "onUpdate:modelValue": ($event: any) => ((props.item.insuranceRate) = $event)
                                                }, null, 8, ["onChange", "modelValue", "onUpdate:modelValue"])
                                              ]),
                                              _createElementVNode("td", _hoisted_23, [
                                                _createVNode(_component_oss_text_field_filled, {
                                                  disabled: "",
                                                  "hide-details": "auto",
                                                  modelValue: props.item.monthlyAmount,
                                                  "onUpdate:modelValue": ($event: any) => ((props.item.monthlyAmount) = $event)
                                                }, null, 8, ["modelValue", "onUpdate:modelValue"])
                                              ]),
                                              _createElementVNode("td", _hoisted_24, [
                                                _createVNode(_component_oss_text_field_filled, {
                                                  disabled: "",
                                                  "hide-details": "auto",
                                                  modelValue: props.item.totalCost,
                                                  "onUpdate:modelValue": ($event: any) => ((props.item.totalCost) = $event)
                                                }, null, 8, ["modelValue", "onUpdate:modelValue"])
                                              ]),
                                              _createElementVNode("td", _hoisted_25, [
                                                _createVNode(_component_v_tooltip, { location: "bottom" }, {
                                                  activator: _withCtx(({ props }) => [
                                                    _createVNode(_component_v_icon, _mergeProps({
                                                      onClick: ($event: any) => {
                                                                            _ctx.activeItemType = 'loan';
                                                                            _ctx.deleteLine(props.index);
                                                                        }
                                                    }, props), {
                                                      default: _withCtx(() => _cache[61] || (_cache[61] = [
                                                        _createTextVNode("$oss-trash")
                                                      ])),
                                                      _: 2
                                                    }, 1040, ["onClick"])
                                                  ]),
                                                  default: _withCtx(() => [
                                                    _cache[62] || (_cache[62] = _createElementVNode("span", null, "Supprimer la ligne", -1))
                                                  ]),
                                                  _: 2
                                                }, 1024),
                                                _createVNode(_component_v_tooltip, { location: "bottom" }, {
                                                  activator: _withCtx(({ props }) => [
                                                    _createVNode(_component_v_icon, _mergeProps({
                                                      onClick: ($event: any) => (
                                                                            _ctx.reinitializeLine(
                                                                                props.index,
                                                                            )
                                                                        )
                                                    }, props), {
                                                      default: _withCtx(() => _cache[63] || (_cache[63] = [
                                                        _createTextVNode("$oss-file")
                                                      ])),
                                                      _: 2
                                                    }, 1040, ["onClick"])
                                                  ]),
                                                  default: _withCtx(() => [
                                                    _cache[64] || (_cache[64] = _createElementVNode("span", null, "Réinitialiser la ligne", -1))
                                                  ]),
                                                  _: 2
                                                }, 1024)
                                              ])
                                            ])
                                          ]),
                                          [`body.append`]: _withCtx(({ columns }) => [
                                            _createElementVNode("tr", null, [
                                              _createElementVNode("td", {
                                                colspan: columns.length
                                              }, [
                                                _createElementVNode("div", _hoisted_27, [
                                                  _createVNode(_component_v_btn, {
                                                    rounded: "",
                                                    elevation: "0",
                                                    onClick: _cache[3] || (_cache[3] = ($event: any) => (_ctx.addLoan())),
                                                    size: "small"
                                                  }, {
                                                    default: _withCtx(() => _cache[65] || (_cache[65] = [
                                                      _createTextVNode(" Ajouter une ligne ")
                                                    ])),
                                                    _: 1
                                                  })
                                                ])
                                              ], 8, _hoisted_26)
                                            ])
                                          ]),
                                          _: 2
                                        }, 1032, ["items", "headers", "itemPerPage"])
                                      ]),
                                      _: 1
                                    })
                                  ]),
                                  _: 1
                                }),
                                _createVNode(_component_v_expansion_panel, { class: "py-0 my-0" }, {
                                  default: _withCtx(() => [
                                    _createVNode(_component_v_expansion_panel_title, { class: "py-0 my-0" }, {
                                      default: _withCtx(() => _cache[66] || (_cache[66] = [
                                        _createElementVNode("h3", null, "Subventions d'investissement", -1)
                                      ])),
                                      _: 1
                                    }),
                                    _createVNode(_component_v_expansion_panel_text, { class: "py-0 my-0" }, {
                                      default: _withCtx(() => [
                                        _createVNode(_component_v_data_table, {
                                          items: _ctx.formBff.fundings.investmentGrants,
                                          headers: _ctx.investmentGrantHeaders,
                                          itemsPerPage: 
                                                    _ctx.formBff.fundings.investmentGrants.length
                                                ,
                                          "hide-default-footer": "",
                                          class: "table"
                                        }, {
                                          item: _withCtx((props) => [
                                            _createElementVNode("tr", null, [
                                              (_ctx.selectedPartition)
                                                ? (_openBlock(), _createElementBlock("td", _hoisted_28, [
                                                    _createVNode(_component_v_combobox_filled, {
                                                      modelValue: props.item.tag,
                                                      "onUpdate:modelValue": ($event: any) => ((props.item.tag) = $event),
                                                      items: _ctx.tagsSelection,
                                                      "item-value": "id",
                                                      dense: "",
                                                      "hide-details": "auto",
                                                      onChange: ($event: any) => (
                                                                    _ctx.updateTagsSelection(props.item)
                                                                ),
                                                      "item-title": (item) => item.name
                                                    }, null, 8, ["modelValue", "onUpdate:modelValue", "items", "onChange", "item-title"])
                                                  ]))
                                                : _createCommentVNode("", true),
                                              _createElementVNode("td", _hoisted_29, [
                                                _createVNode(_component_v_text_field_filled, {
                                                  modelValue: props.item.title,
                                                  "onUpdate:modelValue": ($event: any) => ((props.item.title) = $event),
                                                  "hide-details": "auto",
                                                  density: "compact"
                                                }, null, 8, ["modelValue", "onUpdate:modelValue"])
                                              ]),
                                              _createElementVNode("td", _hoisted_30, [
                                                _createVNode(_component_oss_date_picker_filled, {
                                                  date: 
                                                                    _ctx.transformGapToDate(
                                                                        props.item.monthGap,
                                                                    )
                                                                ,
                                                  onChangeDate: _ctx.assignItemDate,
                                                  onClose: ($event: any) => (
                                                                    _ctx.transformDateToGap(props.item)
                                                                ),
                                                  type: "month",
                                                  format: "MM-YYYY",
                                                  "text-field-readonly": false,
                                                  "hide-details": "auto"
                                                }, null, 8, ["date", "onChangeDate", "onClose"])
                                              ]),
                                              _createElementVNode("td", _hoisted_31, [
                                                _createVNode(_component_oss_text_field_filled, {
                                                  "hide-details": "auto",
                                                  modelValue: props.item.amount,
                                                  "onUpdate:modelValue": ($event: any) => ((props.item.amount) = $event)
                                                }, null, 8, ["modelValue", "onUpdate:modelValue"])
                                              ]),
                                              _createElementVNode("td", _hoisted_32, [
                                                _createVNode(_component_v_select_filled, {
                                                  modelValue: props.item.amortizationLaw,
                                                  "onUpdate:modelValue": ($event: any) => ((props.item.amortizationLaw) = $event),
                                                  items: _ctx.investmentsAmortizationLaws,
                                                  "item-value": "id",
                                                  "hide-details": "auto",
                                                  density: "compact",
                                                  "item-title": (item) => item.name
                                                }, null, 8, ["modelValue", "onUpdate:modelValue", "items", "item-title"])
                                              ]),
                                              _createElementVNode("td", _hoisted_33, [
                                                _createVNode(_component_v_select_filled, {
                                                  modelValue: 
                                                                    props.item.amortizationDuration
                                                                ,
                                                  "onUpdate:modelValue": ($event: any) => ((
                                                                    props.item.amortizationDuration
                                                                ) = $event),
                                                  items: _ctx.durationDelays,
                                                  "item-value": "id",
                                                  "hide-details": "auto",
                                                  density: "compact",
                                                  "item-title": (item) => item.name
                                                }, null, 8, ["modelValue", "onUpdate:modelValue", "items", "item-title"])
                                              ]),
                                              _createElementVNode("td", _hoisted_34, [
                                                _createVNode(_component_v_tooltip, { location: "bottom" }, {
                                                  activator: _withCtx(({ props }) => [
                                                    _createVNode(_component_v_icon, _mergeProps({
                                                      onClick: ($event: any) => {
                                                                            _ctx.activeItemType =
                                                                                'investmentGrant';
                                                                            _ctx.deleteLine(props.index);
                                                                        }
                                                    }, props), {
                                                      default: _withCtx(() => _cache[67] || (_cache[67] = [
                                                        _createTextVNode("$oss-trash")
                                                      ])),
                                                      _: 2
                                                    }, 1040, ["onClick"])
                                                  ]),
                                                  default: _withCtx(() => [
                                                    _cache[68] || (_cache[68] = _createElementVNode("span", null, "Supprimer la ligne", -1))
                                                  ]),
                                                  _: 2
                                                }, 1024),
                                                _createVNode(_component_v_tooltip, { location: "bottom" }, {
                                                  activator: _withCtx(({ props }) => [
                                                    _createVNode(_component_v_icon, _mergeProps({
                                                      onClick: ($event: any) => (
                                                                            _ctx.reinitializeLine(
                                                                                props.index,
                                                                            )
                                                                        )
                                                    }, props), {
                                                      default: _withCtx(() => _cache[69] || (_cache[69] = [
                                                        _createTextVNode("$oss-file")
                                                      ])),
                                                      _: 2
                                                    }, 1040, ["onClick"])
                                                  ]),
                                                  default: _withCtx(() => [
                                                    _cache[70] || (_cache[70] = _createElementVNode("span", null, "Réinitialiser la ligne", -1))
                                                  ]),
                                                  _: 2
                                                }, 1024)
                                              ])
                                            ])
                                          ]),
                                          [`body.append`]: _withCtx(({ columns }) => [
                                            _createElementVNode("tr", null, [
                                              _createElementVNode("td", {
                                                colspan: columns.length
                                              }, [
                                                _createElementVNode("div", _hoisted_36, [
                                                  _createVNode(_component_v_btn, {
                                                    rounded: "",
                                                    elevation: "0",
                                                    onClick: _cache[4] || (_cache[4] = ($event: any) => (_ctx.addInvestmentGrant())),
                                                    size: "small"
                                                  }, {
                                                    default: _withCtx(() => _cache[71] || (_cache[71] = [
                                                      _createTextVNode(" Ajouter une ligne ")
                                                    ])),
                                                    _: 1
                                                  })
                                                ])
                                              ], 8, _hoisted_35)
                                            ])
                                          ]),
                                          _: 2
                                        }, 1032, ["items", "headers", "itemsPerPage"])
                                      ]),
                                      _: 1
                                    })
                                  ]),
                                  _: 1
                                })
                              ]),
                              _: 1
                            }, 8, ["modelValue"])
                          ]),
                          _: 1
                        }),
                        _createVNode(_component_v_card_actions, { class: "d-flex justify-center align-end" }, {
                          default: _withCtx(() => [
                            _createVNode(_component_v_btn_prev, {
                              onClick: _cache[6] || (_cache[6] = ($event: any) => (_ctx.previous()))
                            }),
                            _createVNode(_component_v_btn_next, {
                              onClick: _cache[7] || (_cache[7] = ($event: any) => (_ctx.next()))
                            })
                          ]),
                          _: 1
                        })
                      ]),
                      _: 1
                    })
                  ]),
                  _: 1
                }),
                _createVNode(_component_v_window_item, { value: "2" }, {
                  default: _withCtx(() => [
                    _createVNode(_component_v_card, { style: {"box-shadow":"none"} }, {
                      default: _withCtx(() => [
                        _createVNode(_component_v_data_table, {
                          items: _ctx.formBff.activities,
                          headers: _ctx.activitiesHeaders,
                          itemsPerPage: _ctx.formBff.activities.length,
                          "single-expand": false,
                          expanded: _ctx.activitiesExpanded,
                          "onUpdate:expanded": _cache[10] || (_cache[10] = ($event: any) => ((_ctx.activitiesExpanded) = $event)),
                          "show-expand": "",
                          "hide-default-footer": "",
                          class: "table"
                        }, {
                          item: _withCtx((props) => [
                            _createElementVNode("tr", null, [
                              (_ctx.selectedPartition)
                                ? (_openBlock(), _createElementBlock("td", _hoisted_37, [
                                    _createVNode(_component_v_combobox_filled, {
                                      modelValue: props.item.tag,
                                      "onUpdate:modelValue": ($event: any) => ((props.item.tag) = $event),
                                      items: _ctx.tagsSelection,
                                      "item-value": "id",
                                      dense: "",
                                      "hide-details": "auto",
                                      onChange: ($event: any) => (_ctx.updateTagsSelection(props.item)),
                                      "item-title": (item) => item.name
                                    }, null, 8, ["modelValue", "onUpdate:modelValue", "items", "onChange", "item-title"])
                                  ]))
                                : _createCommentVNode("", true),
                              _createElementVNode("td", _hoisted_38, [
                                _createVNode(_component_v_text_field_filled, {
                                  modelValue: props.item.title,
                                  "onUpdate:modelValue": ($event: any) => ((props.item.title) = $event),
                                  "hide-details": "auto",
                                  "data-cy": "BudgetFormFull-libelle",
                                  density: "compact"
                                }, null, 8, ["modelValue", "onUpdate:modelValue"])
                              ]),
                              (
                                                _ctx.availableSalesAccounts.length &&
                                                _ctx.availableSalesAccounts.length > 0
                                            )
                                ? (_openBlock(), _createElementBlock("td", _hoisted_39, [
                                    _createVNode(_component_v_select_filled, {
                                      modelValue: props.item.salesAccount,
                                      "onUpdate:modelValue": ($event: any) => ((props.item.salesAccount) = $event),
                                      items: _ctx.availableSalesAccounts,
                                      "item-value": "name",
                                      "hide-details": "auto",
                                      disabled: 
                                                    props.item.isLineReported &&
                                                    _ctx.groupingMode === 'AA'
                                                ,
                                      density: "compact",
                                      "item-title": (item) => item.description
                                    }, null, 8, ["modelValue", "onUpdate:modelValue", "items", "disabled", "item-title"])
                                  ]))
                                : _createCommentVNode("", true),
                              _createElementVNode("td", _hoisted_40, [
                                _createVNode(_component_v_checkbox, {
                                  modelValue: props.item.activeReporting,
                                  "onUpdate:modelValue": [($event: any) => ((props.item.activeReporting) = $event), ($event: any) => (_ctx.onReportingChanged(props.item))],
                                  ripple: false,
                                  disabled: !props.item.isLineReported
                                }, null, 8, ["modelValue", "onUpdate:modelValue", "disabled"])
                              ]),
                              _createElementVNode("td", _hoisted_41, [
                                _createVNode(_component_oss_text_field_filled, {
                                  "hide-details": "auto",
                                  disabled: "",
                                  modelValue: props.item.amountNM1,
                                  "onUpdate:modelValue": ($event: any) => ((props.item.amountNM1) = $event)
                                }, null, 8, ["modelValue", "onUpdate:modelValue"])
                              ]),
                              _createElementVNode("td", _hoisted_42, [
                                _createVNode(_component_oss_text_field_filled, {
                                  "hide-details": "auto",
                                  disabled: 
                                                    _ctx.disableYearlyAmount(props.item, 0) &&
                                                    !props.item.activeReporting
                                                ,
                                  onChange: ($event: any) => (
                                                    _ctx.modifyDetails(
                                                        props.item,
                                                        false,
                                                        _ctx.updateAllWhenFirstYearChange,
                                                        _ctx.buildActivityDefaultDetails,
                                                    )
                                                ),
                                  modelValue: props.item.years[0].evolutionPercentage,
                                  "onUpdate:modelValue": ($event: any) => ((props.item.years[0].evolutionPercentage) = $event)
                                }, null, 8, ["disabled", "onChange", "modelValue", "onUpdate:modelValue"])
                              ]),
                              _createElementVNode("td", _hoisted_43, [
                                _createVNode(_component_oss_text_field_filled, {
                                  "hide-details": "auto",
                                  disabled: 
                                                    _ctx.disableYearlyAmount(props.item, 0) &&
                                                    !props.item.activeReporting
                                                ,
                                  onChange: ($event: any) => (
                                                    _ctx.modifyDetails(
                                                        props.item,
                                                        true,
                                                        _ctx.updateAllWhenFirstYearChange,
                                                        _ctx.buildActivityDefaultDetails,
                                                    )
                                                ),
                                  "data-cy": "BudgetFormFull-amount",
                                  modelValue: props.item.years[0].amount,
                                  "onUpdate:modelValue": ($event: any) => ((props.item.years[0].amount) = $event)
                                }, null, 8, ["disabled", "onChange", "modelValue", "onUpdate:modelValue"])
                              ]),
                              (props.item.years.length > 1)
                                ? (_openBlock(), _createElementBlock("td", _hoisted_44, [
                                    _createVNode(_component_oss_text_field_filled, {
                                      "hide-details": "auto",
                                      disabled: 
                                                    _ctx.disableYearlyAmount(props.item, 1) &&
                                                    !props.item.activeReporting
                                                ,
                                      onChange: ($event: any) => (
                                                    _ctx.modifyDetails(
                                                        props.item,
                                                        1,
                                                        _ctx.updateAmountsWhenPercentageChange,
                                                        _ctx.buildActivityDefaultDetails,
                                                    )
                                                ),
                                      modelValue: props.item.years[1].evolutionPercentage,
                                      "onUpdate:modelValue": ($event: any) => ((props.item.years[1].evolutionPercentage) = $event)
                                    }, null, 8, ["disabled", "onChange", "modelValue", "onUpdate:modelValue"])
                                  ]))
                                : _createCommentVNode("", true),
                              (props.item.years.length > 1)
                                ? (_openBlock(), _createElementBlock("td", _hoisted_45, [
                                    _createVNode(_component_oss_text_field_filled, {
                                      "hide-details": "auto",
                                      disabled: 
                                                    _ctx.disableYearlyAmount(props.item, 1) &&
                                                    !props.item.activeReporting
                                                ,
                                      onChange: ($event: any) => (
                                                    _ctx.modifyDetails(
                                                        props.item,
                                                        1,
                                                        _ctx.updateAllWhenAmountChange,
                                                        _ctx.buildActivityDefaultDetails,
                                                    )
                                                ),
                                      "data-cy": "test9",
                                      modelValue: props.item.years[1].amount,
                                      "onUpdate:modelValue": ($event: any) => ((props.item.years[1].amount) = $event)
                                    }, null, 8, ["disabled", "onChange", "modelValue", "onUpdate:modelValue"])
                                  ]))
                                : _createCommentVNode("", true),
                              (props.item.years.length > 2)
                                ? (_openBlock(), _createElementBlock("td", _hoisted_46, [
                                    _createVNode(_component_oss_text_field_filled, {
                                      "hide-details": "auto",
                                      disabled: 
                                                    _ctx.disableYearlyAmount(props.item, 2) &&
                                                    !props.item.activeReporting
                                                ,
                                      onChange: ($event: any) => (
                                                    _ctx.modifyDetails(
                                                        props.item,
                                                        2,
                                                        _ctx.updateAmountsWhenPercentageChange,
                                                        _ctx.buildActivityDefaultDetails,
                                                    )
                                                ),
                                      "data-cy": "test10",
                                      modelValue: props.item.years[2].evolutionPercentage,
                                      "onUpdate:modelValue": ($event: any) => ((props.item.years[2].evolutionPercentage) = $event)
                                    }, null, 8, ["disabled", "onChange", "modelValue", "onUpdate:modelValue"])
                                  ]))
                                : _createCommentVNode("", true),
                              (props.item.years.length > 2)
                                ? (_openBlock(), _createElementBlock("td", _hoisted_47, [
                                    _createVNode(_component_oss_text_field_filled, {
                                      "hide-details": "auto",
                                      disabled: 
                                                    _ctx.disableYearlyAmount(props.item, 2) &&
                                                    !props.item.activeReporting
                                                ,
                                      onChange: ($event: any) => (
                                                    _ctx.modifyDetails(
                                                        props.item,
                                                        2,
                                                        _ctx.updateAllWhenAmountChange,
                                                        _ctx.buildActivityDefaultDetails,
                                                    )
                                                ),
                                      "data-cy": "test11",
                                      modelValue: props.item.years[2].amount,
                                      "onUpdate:modelValue": ($event: any) => ((props.item.years[2].amount) = $event)
                                    }, null, 8, ["disabled", "onChange", "modelValue", "onUpdate:modelValue"])
                                  ]))
                                : _createCommentVNode("", true),
                              (props.item.years.length > 3)
                                ? (_openBlock(), _createElementBlock("td", _hoisted_48, [
                                    _createVNode(_component_oss_text_field_filled, {
                                      "hide-details": "auto",
                                      disabled: 
                                                    _ctx.disableYearlyAmount(props.item, 3) &&
                                                    !props.item.activeReporting
                                                ,
                                      onChange: ($event: any) => (
                                                    _ctx.modifyDetails(
                                                        props.item,
                                                        3,
                                                        _ctx.updateAmountsWhenPercentageChange,
                                                        _ctx.buildActivityDefaultDetails,
                                                    )
                                                ),
                                      "data-cy": "test12",
                                      modelValue: props.item.years[3].evolutionPercentage,
                                      "onUpdate:modelValue": ($event: any) => ((props.item.years[3].evolutionPercentage) = $event)
                                    }, null, 8, ["disabled", "onChange", "modelValue", "onUpdate:modelValue"])
                                  ]))
                                : _createCommentVNode("", true),
                              (props.item.years.length > 3)
                                ? (_openBlock(), _createElementBlock("td", _hoisted_49, [
                                    _createVNode(_component_oss_text_field_filled, {
                                      "hide-details": "auto",
                                      disabled: 
                                                    _ctx.disableYearlyAmount(props.item, 3) &&
                                                    !props.item.activeReporting
                                                ,
                                      onChange: ($event: any) => (
                                                    _ctx.modifyDetails(
                                                        props.item,
                                                        3,
                                                        _ctx.updateAllWhenAmountChange,
                                                        _ctx.buildActivityDefaultDetails,
                                                    )
                                                ),
                                      modelValue: props.item.years[3].amount,
                                      "onUpdate:modelValue": ($event: any) => ((props.item.years[3].amount) = $event)
                                    }, null, 8, ["disabled", "onChange", "modelValue", "onUpdate:modelValue"])
                                  ]))
                                : _createCommentVNode("", true),
                              (props.item.years.length > 4)
                                ? (_openBlock(), _createElementBlock("td", _hoisted_50, [
                                    _createVNode(_component_oss_text_field_filled, {
                                      "hide-details": "auto",
                                      disabled: 
                                                    _ctx.disableYearlyAmount(props.item, 4) &&
                                                    !props.item.activeReporting
                                                ,
                                      onChange: ($event: any) => (
                                                    _ctx.modifyDetails(
                                                        props.item,
                                                        4,
                                                        _ctx.updateAmountsWhenPercentageChange,
                                                        _ctx.buildActivityDefaultDetails,
                                                    )
                                                ),
                                      modelValue: props.item.years[4].evolutionPercentage,
                                      "onUpdate:modelValue": ($event: any) => ((props.item.years[4].evolutionPercentage) = $event)
                                    }, null, 8, ["disabled", "onChange", "modelValue", "onUpdate:modelValue"])
                                  ]))
                                : _createCommentVNode("", true),
                              (props.item.years.length > 4)
                                ? (_openBlock(), _createElementBlock("td", _hoisted_51, [
                                    _createVNode(_component_oss_text_field_filled, {
                                      "hide-details": "auto",
                                      disabled: 
                                                    _ctx.disableYearlyAmount(props.item, 4) &&
                                                    !props.item.activeReporting
                                                ,
                                      onChange: ($event: any) => (
                                                    _ctx.modifyDetails(
                                                        props.item,
                                                        4,
                                                        _ctx.updateAllWhenAmountChange,
                                                        _ctx.buildActivityDefaultDetails,
                                                    )
                                                ),
                                      modelValue: props.item.years[4].amount,
                                      "onUpdate:modelValue": ($event: any) => ((props.item.years[4].amount) = $event)
                                    }, null, 8, ["disabled", "onChange", "modelValue", "onUpdate:modelValue"])
                                  ]))
                                : _createCommentVNode("", true),
                              _createElementVNode("td", _hoisted_52, [
                                _createVNode(_component_oss_text_field_filled, {
                                  "hide-details": "auto",
                                  onChange: ($event: any) => (_ctx.buildActivityDefaultDetails(props.item)),
                                  "data-cy": "BudgetFormFull-testEvol",
                                  modelValue: props.item.marginRate,
                                  "onUpdate:modelValue": ($event: any) => ((props.item.marginRate) = $event)
                                }, null, 8, ["onChange", "modelValue", "onUpdate:modelValue"])
                              ]),
                              _createElementVNode("td", _hoisted_53, [
                                _createVNode(_component_v_select_filled, {
                                  modelValue: props.item.paymentDelay,
                                  "onUpdate:modelValue": ($event: any) => ((props.item.paymentDelay) = $event),
                                  items: _ctx.paymentDelays,
                                  "item-value": "id",
                                  required: "",
                                  "hide-details": "auto",
                                  density: "compact",
                                  "item-title": (item) => item.name
                                }, null, 8, ["modelValue", "onUpdate:modelValue", "items", "item-title"])
                              ]),
                              _createElementVNode("td", _hoisted_54, [
                                _createVNode(_component_oss_text_field_filled, {
                                  "hide-details": "auto",
                                  modelValue: props.item.vatRate,
                                  "onUpdate:modelValue": ($event: any) => ((props.item.vatRate) = $event)
                                }, null, 8, ["modelValue", "onUpdate:modelValue"])
                              ]),
                              _createElementVNode("td", _hoisted_55, [
                                _createVNode(_component_v_select_filled, {
                                  modelValue: props.item.vatCollectionTime,
                                  "onUpdate:modelValue": ($event: any) => ((props.item.vatCollectionTime) = $event),
                                  items: _ctx.vatCollectionTimes,
                                  "item-value": "id",
                                  required: "",
                                  "hide-details": "auto",
                                  density: "compact",
                                  "item-title": (item) => item.name
                                }, null, 8, ["modelValue", "onUpdate:modelValue", "items", "item-title"])
                              ]),
                              _createElementVNode("td", _hoisted_56, [
                                _withDirectives((_openBlock(), _createBlock(_component_v_icon, {
                                  onClick: ($event: any) => (props.toggleExpand(props.internalItem)),
                                  "data-cy": "BudgetFormFull-detail"
                                }, {
                                  default: _withCtx(() => _cache[72] || (_cache[72] = [
                                    _createTextVNode("$oss-analysis")
                                  ])),
                                  _: 2
                                }, 1032, ["onClick"])), [
                                  [_directive_tooltip, 'Détail de la ligne', "bottom"]
                                ])
                              ]),
                              _createElementVNode("td", _hoisted_57, [
                                _createVNode(_component_v_tooltip, { location: "bottom" }, {
                                  activator: _withCtx(({ props }) => [
                                    _createVNode(_component_v_icon, _mergeProps({
                                      onClick: ($event: any) => {
                                                            _ctx.activeItemType = 'activity';
                                                            _ctx.deleteLine(props.index);
                                                        }
                                    }, props), {
                                      default: _withCtx(() => _cache[73] || (_cache[73] = [
                                        _createTextVNode("$oss-trash")
                                      ])),
                                      _: 2
                                    }, 1040, ["onClick"])
                                  ]),
                                  default: _withCtx(() => [
                                    _cache[74] || (_cache[74] = _createElementVNode("span", null, "Supprimer la ligne ", -1))
                                  ]),
                                  _: 2
                                }, 1024),
                                _createVNode(_component_v_tooltip, { location: "bottom" }, {
                                  activator: _withCtx(({ props }) => [
                                    _createVNode(_component_v_icon, _mergeProps({
                                      onClick: ($event: any) => (_ctx.reinitializeLine(props.index))
                                    }, props), {
                                      default: _withCtx(() => _cache[75] || (_cache[75] = [
                                        _createTextVNode("$oss-file")
                                      ])),
                                      _: 2
                                    }, 1040, ["onClick"])
                                  ]),
                                  default: _withCtx(() => [
                                    _cache[76] || (_cache[76] = _createElementVNode("span", null, "Réinitialiser la ligne", -1))
                                  ]),
                                  _: 2
                                }, 1024)
                              ])
                            ])
                          ]),
                          "expanded-row": _withCtx(({ columns, item }) => [
                            _createElementVNode("td", {
                              colspan: columns.length
                            }, [
                              _createVNode(_component_ActivityDetails, {
                                activity: item,
                                parameters: _ctx.parameters,
                                date: _ctx.date,
                                isDetailEditable: !item.activeReporting,
                                onStoreActiveDetails: _cache[8] || (_cache[8] = ($event: any) => (_ctx.onStoreActiveDetails($event)))
                              }, null, 8, ["activity", "parameters", "date", "isDetailEditable"])
                            ], 8, _hoisted_58)
                          ]),
                          [`body.append`]: _withCtx(({ columns }) => [
                            _createElementVNode("tr", null, [
                              _createElementVNode("td", {
                                colspan: columns.length
                              }, [
                                _createElementVNode("div", _hoisted_60, [
                                  _createVNode(_component_v_btn, {
                                    rounded: "",
                                    elevation: "0",
                                    onClick: _cache[9] || (_cache[9] = ($event: any) => (_ctx.addActivity())),
                                    size: "small"
                                  }, {
                                    default: _withCtx(() => _cache[77] || (_cache[77] = [
                                      _createTextVNode(" Ajouter une ligne ")
                                    ])),
                                    _: 1
                                  })
                                ])
                              ], 8, _hoisted_59)
                            ])
                          ]),
                          _: 2
                        }, 1032, ["items", "headers", "itemsPerPage", "expanded"]),
                        _createVNode(_component_v_card_actions, { class: "d-flex justify-center align-end" }, {
                          default: _withCtx(() => [
                            _createVNode(_component_v_btn_prev, {
                              onClick: _cache[11] || (_cache[11] = ($event: any) => (_ctx.previous()))
                            }),
                            _createVNode(_component_v_btn_next, {
                              onClick: _cache[12] || (_cache[12] = ($event: any) => (_ctx.next()))
                            })
                          ]),
                          _: 1
                        })
                      ]),
                      _: 1
                    })
                  ]),
                  _: 1
                }),
                _createVNode(_component_v_window_item, { value: "3" }, {
                  default: _withCtx(() => [
                    _createVNode(_component_v_card, { style: {"box-shadow":"none"} }, {
                      default: _withCtx(() => [
                        _createVNode(_component_v_card_text, { stye: "height:65vh;" }, {
                          default: _withCtx(() => [
                            _createVNode(_component_v_expansion_panels, {
                              modelValue: _ctx.chargesExpanded,
                              "onUpdate:modelValue": _cache[17] || (_cache[17] = ($event: any) => ((_ctx.chargesExpanded) = $event)),
                              multiple: "",
                              accordion: ""
                            }, {
                              default: _withCtx(() => [
                                _createVNode(_component_v_expansion_panel, { class: "py-0 my-0" }, {
                                  default: _withCtx(() => [
                                    _createVNode(_component_v_expansion_panel_title, { class: "py-0 my-0" }, {
                                      default: _withCtx(() => _cache[78] || (_cache[78] = [
                                        _createElementVNode("h3", null, "Charges fixes récurrentes", -1)
                                      ])),
                                      _: 1
                                    }),
                                    _createVNode(_component_v_expansion_panel_text, { class: "py-0 my-0" }, {
                                      default: _withCtx(() => [
                                        _createVNode(_component_v_data_table, {
                                          items: _ctx.formBff.charges.recurringCharges,
                                          headers: _ctx.chargesHeaders,
                                          itemsPerPage: 
                                                    _ctx.formBff.charges.recurringCharges.length
                                                ,
                                          "single-expand": false,
                                          expanded: _ctx.recurringChargesExpanded,
                                          "onUpdate:expanded": _cache[15] || (_cache[15] = ($event: any) => ((_ctx.recurringChargesExpanded) = $event)),
                                          "item-key": "title",
                                          "show-expand": "",
                                          "hide-default-footer": "",
                                          class: "table"
                                        }, {
                                          item: _withCtx((props) => [
                                            _createElementVNode("tr", null, [
                                              (_ctx.selectedPartition)
                                                ? (_openBlock(), _createElementBlock("td", _hoisted_61, [
                                                    _createVNode(_component_v_combobox_filled, {
                                                      modelValue: props.item.tag,
                                                      "onUpdate:modelValue": ($event: any) => ((props.item.tag) = $event),
                                                      items: _ctx.tagsSelection,
                                                      "item-value": "id",
                                                      dense: "",
                                                      "hide-details": "auto",
                                                      onChange: ($event: any) => (
                                                                    _ctx.updateTagsSelection(props.item)
                                                                ),
                                                      "item-title": (item) => item.name
                                                    }, null, 8, ["modelValue", "onUpdate:modelValue", "items", "onChange", "item-title"])
                                                  ]))
                                                : _createCommentVNode("", true),
                                              _createElementVNode("td", _hoisted_62, [
                                                _createVNode(_component_v_combobox_filled, {
                                                  modelValue: props.item.title,
                                                  "onUpdate:modelValue": ($event: any) => ((props.item.title) = $event),
                                                  items: _ctx.recurringChargesItems,
                                                  dense: "",
                                                  "hide-details": "auto",
                                                  "data-cy": "name"
                                                }, null, 8, ["modelValue", "onUpdate:modelValue", "items"])
                                              ]),
                                              _createElementVNode("td", _hoisted_63, [
                                                _createVNode(_component_v_checkbox, {
                                                  modelValue: props.item.activeReporting,
                                                  "onUpdate:modelValue": [($event: any) => ((props.item.activeReporting) = $event), ($event: any) => (
                                                                    _ctx.onReportingChanged(props.item)
                                                                )],
                                                  ripple: false,
                                                  disabled: 
                                                                    !props.item.isLineReported
                                                                
                                                }, null, 8, ["modelValue", "onUpdate:modelValue", "disabled"])
                                              ]),
                                              _createElementVNode("td", _hoisted_64, [
                                                _createVNode(_component_oss_text_field_filled, {
                                                  "hide-details": "auto",
                                                  disabled: "",
                                                  modelValue: props.item.amountNM1,
                                                  "onUpdate:modelValue": ($event: any) => ((props.item.amountNM1) = $event)
                                                }, null, 8, ["modelValue", "onUpdate:modelValue"])
                                              ]),
                                              _createElementVNode("td", _hoisted_65, [
                                                _createVNode(_component_oss_text_field_filled, {
                                                  "hide-details": "auto",
                                                  disabled: 
                                                                    _ctx.disableYearlyAmount(
                                                                        props.item,
                                                                        0,
                                                                    ) && !props.item.activeReporting
                                                                ,
                                                  onChange: ($event: any) => (
                                                                    _ctx.modifyDetails(
                                                                        props.item,
                                                                        false,
                                                                        _ctx.updateAllWhenFirstYearChange,
                                                                        _ctx.buildChargeDefaultDetails,
                                                                    )
                                                                ),
                                                  modelValue: 
                                                                    props.item.years[0]
                                                                        .evolutionPercentage
                                                                ,
                                                  "onUpdate:modelValue": ($event: any) => ((
                                                                    props.item.years[0]
                                                                        .evolutionPercentage
                                                                ) = $event)
                                                }, null, 8, ["disabled", "onChange", "modelValue", "onUpdate:modelValue"])
                                              ]),
                                              _createElementVNode("td", _hoisted_66, [
                                                _createVNode(_component_oss_text_field_filled, {
                                                  "hide-details": "auto",
                                                  disabled: 
                                                                    _ctx.disableYearlyAmount(
                                                                        props.item,
                                                                        0,
                                                                    ) && !props.item.activeReporting
                                                                ,
                                                  onChange: ($event: any) => (
                                                                    _ctx.modifyDetails(
                                                                        props.item,
                                                                        true,
                                                                        _ctx.updateAllWhenFirstYearChange,
                                                                        _ctx.buildChargeDefaultDetails,
                                                                    )
                                                                ),
                                                  modelValue: props.item.years[0].amount,
                                                  "onUpdate:modelValue": ($event: any) => ((props.item.years[0].amount) = $event)
                                                }, null, 8, ["disabled", "onChange", "modelValue", "onUpdate:modelValue"])
                                              ]),
                                              (props.item.years.length > 1)
                                                ? (_openBlock(), _createElementBlock("td", _hoisted_67, [
                                                    _createVNode(_component_oss_text_field_filled, {
                                                      "hide-details": "auto",
                                                      disabled: 
                                                                    _ctx.disableYearlyAmount(
                                                                        props.item,
                                                                        1,
                                                                    ) && !props.item.activeReporting
                                                                ,
                                                      onChange: ($event: any) => (
                                                                    _ctx.modifyDetails(
                                                                        props.item,
                                                                        1,
                                                                        _ctx.updateAmountsWhenPercentageChange,
                                                                        _ctx.buildChargeDefaultDetails,
                                                                    )
                                                                ),
                                                      modelValue: 
                                                                    props.item.years[1]
                                                                        .evolutionPercentage
                                                                ,
                                                      "onUpdate:modelValue": ($event: any) => ((
                                                                    props.item.years[1]
                                                                        .evolutionPercentage
                                                                ) = $event)
                                                    }, null, 8, ["disabled", "onChange", "modelValue", "onUpdate:modelValue"])
                                                  ]))
                                                : _createCommentVNode("", true),
                                              (props.item.years.length > 1)
                                                ? (_openBlock(), _createElementBlock("td", _hoisted_68, [
                                                    _createVNode(_component_oss_text_field_filled, {
                                                      "hide-details": "auto",
                                                      disabled: 
                                                                    _ctx.disableYearlyAmount(
                                                                        props.item,
                                                                        1,
                                                                    ) && !props.item.activeReporting
                                                                ,
                                                      onChange: ($event: any) => (
                                                                    _ctx.modifyDetails(
                                                                        props.item,
                                                                        1,
                                                                        _ctx.updateAllWhenAmountChange,
                                                                        _ctx.buildChargeDefaultDetails,
                                                                    )
                                                                ),
                                                      modelValue: props.item.years[1].amount,
                                                      "onUpdate:modelValue": ($event: any) => ((props.item.years[1].amount) = $event)
                                                    }, null, 8, ["disabled", "onChange", "modelValue", "onUpdate:modelValue"])
                                                  ]))
                                                : _createCommentVNode("", true),
                                              (props.item.years.length > 2)
                                                ? (_openBlock(), _createElementBlock("td", _hoisted_69, [
                                                    _createVNode(_component_oss_text_field_filled, {
                                                      "hide-details": "auto",
                                                      disabled: 
                                                                    _ctx.disableYearlyAmount(
                                                                        props.item,
                                                                        2,
                                                                    ) && !props.item.activeReporting
                                                                ,
                                                      onChange: ($event: any) => (
                                                                    _ctx.modifyDetails(
                                                                        props.item,
                                                                        2,
                                                                        _ctx.updateAmountsWhenPercentageChange,
                                                                        _ctx.buildChargeDefaultDetails,
                                                                    )
                                                                ),
                                                      modelValue: 
                                                                    props.item.years[2]
                                                                        .evolutionPercentage
                                                                ,
                                                      "onUpdate:modelValue": ($event: any) => ((
                                                                    props.item.years[2]
                                                                        .evolutionPercentage
                                                                ) = $event)
                                                    }, null, 8, ["disabled", "onChange", "modelValue", "onUpdate:modelValue"])
                                                  ]))
                                                : _createCommentVNode("", true),
                                              (props.item.years.length > 2)
                                                ? (_openBlock(), _createElementBlock("td", _hoisted_70, [
                                                    _createVNode(_component_oss_text_field_filled, {
                                                      "hide-details": "auto",
                                                      disabled: 
                                                                    _ctx.disableYearlyAmount(
                                                                        props.item,
                                                                        2,
                                                                    ) && !props.item.activeReporting
                                                                ,
                                                      onChange: ($event: any) => (
                                                                    _ctx.modifyDetails(
                                                                        props.item,
                                                                        2,
                                                                        _ctx.updateAllWhenAmountChange,
                                                                        _ctx.buildChargeDefaultDetails,
                                                                    )
                                                                ),
                                                      modelValue: props.item.years[2].amount,
                                                      "onUpdate:modelValue": ($event: any) => ((props.item.years[2].amount) = $event)
                                                    }, null, 8, ["disabled", "onChange", "modelValue", "onUpdate:modelValue"])
                                                  ]))
                                                : _createCommentVNode("", true),
                                              (props.item.years.length > 3)
                                                ? (_openBlock(), _createElementBlock("td", _hoisted_71, [
                                                    _createVNode(_component_oss_text_field_filled, {
                                                      "hide-details": "auto",
                                                      disabled: 
                                                                    _ctx.disableYearlyAmount(
                                                                        props.item,
                                                                        3,
                                                                    ) && !props.item.activeReporting
                                                                ,
                                                      onChange: ($event: any) => (
                                                                    _ctx.modifyDetails(
                                                                        props.item,
                                                                        3,
                                                                        _ctx.updateAmountsWhenPercentageChange,
                                                                        _ctx.buildChargeDefaultDetails,
                                                                    )
                                                                ),
                                                      modelValue: 
                                                                    props.item.years[3]
                                                                        .evolutionPercentage
                                                                ,
                                                      "onUpdate:modelValue": ($event: any) => ((
                                                                    props.item.years[3]
                                                                        .evolutionPercentage
                                                                ) = $event)
                                                    }, null, 8, ["disabled", "onChange", "modelValue", "onUpdate:modelValue"])
                                                  ]))
                                                : _createCommentVNode("", true),
                                              (props.item.years.length > 3)
                                                ? (_openBlock(), _createElementBlock("td", _hoisted_72, [
                                                    _createVNode(_component_oss_text_field_filled, {
                                                      "hide-details": "auto",
                                                      disabled: 
                                                                    _ctx.disableYearlyAmount(
                                                                        props.item,
                                                                        3,
                                                                    ) && !props.item.activeReporting
                                                                ,
                                                      onChange: ($event: any) => (
                                                                    _ctx.modifyDetails(
                                                                        props.item,
                                                                        3,
                                                                        _ctx.updateAllWhenAmountChange,
                                                                        _ctx.buildChargeDefaultDetails,
                                                                    )
                                                                ),
                                                      modelValue: props.item.years[3].amount,
                                                      "onUpdate:modelValue": ($event: any) => ((props.item.years[3].amount) = $event)
                                                    }, null, 8, ["disabled", "onChange", "modelValue", "onUpdate:modelValue"])
                                                  ]))
                                                : _createCommentVNode("", true),
                                              (props.item.years.length > 4)
                                                ? (_openBlock(), _createElementBlock("td", _hoisted_73, [
                                                    _createVNode(_component_oss_text_field_filled, {
                                                      "hide-details": "auto",
                                                      disabled: 
                                                                    _ctx.disableYearlyAmount(
                                                                        props.item,
                                                                        4,
                                                                    ) && !props.item.activeReporting
                                                                ,
                                                      onChange: ($event: any) => (
                                                                    _ctx.modifyDetails(
                                                                        props.item,
                                                                        4,
                                                                        _ctx.updateAmountsWhenPercentageChange,
                                                                        _ctx.buildChargeDefaultDetails,
                                                                    )
                                                                ),
                                                      modelValue: 
                                                                    props.item.years[4]
                                                                        .evolutionPercentage
                                                                ,
                                                      "onUpdate:modelValue": ($event: any) => ((
                                                                    props.item.years[4]
                                                                        .evolutionPercentage
                                                                ) = $event)
                                                    }, null, 8, ["disabled", "onChange", "modelValue", "onUpdate:modelValue"])
                                                  ]))
                                                : _createCommentVNode("", true),
                                              (props.item.years.length > 4)
                                                ? (_openBlock(), _createElementBlock("td", _hoisted_74, [
                                                    _createVNode(_component_oss_text_field_filled, {
                                                      "hide-details": "auto",
                                                      disabled: 
                                                                    _ctx.disableYearlyAmount(
                                                                        props.item,
                                                                        4,
                                                                    ) && !props.item.activeReporting
                                                                ,
                                                      onChange: ($event: any) => (
                                                                    _ctx.modifyDetails(
                                                                        props.item,
                                                                        4,
                                                                        _ctx.updateAllWhenAmountChange,
                                                                        _ctx.buildChargeDefaultDetails,
                                                                    )
                                                                ),
                                                      modelValue: props.item.years[4].amount,
                                                      "onUpdate:modelValue": ($event: any) => ((props.item.years[4].amount) = $event)
                                                    }, null, 8, ["disabled", "onChange", "modelValue", "onUpdate:modelValue"])
                                                  ]))
                                                : _createCommentVNode("", true),
                                              _createElementVNode("td", _hoisted_75, [
                                                _createVNode(_component_v_select_filled, {
                                                  modelValue: props.item.frequency,
                                                  "onUpdate:modelValue": [($event: any) => ((props.item.frequency) = $event), ($event: any) => (
                                                                    _ctx.fillSpecificDueDates(
                                                                        props.item,
                                                                        props.index,
                                                                    )
                                                                )],
                                                  items: _ctx.chargesFrequency,
                                                  "item-value": "id",
                                                  "hide-details": "auto",
                                                  disabled: 
                                                                    props.item.isLineReported
                                                                ,
                                                  density: "compact",
                                                  "item-title": (item) => item.name
                                                }, null, 8, ["modelValue", "onUpdate:modelValue", "items", "disabled", "item-title"])
                                              ]),
                                              _createElementVNode("td", _hoisted_76, [
                                                _createVNode(_component_v_select_filled, {
                                                  modelValue: props.item.paymentDelay,
                                                  "onUpdate:modelValue": ($event: any) => ((props.item.paymentDelay) = $event),
                                                  items: _ctx.paymentDelays,
                                                  "item-value": "id",
                                                  required: "",
                                                  "hide-details": "auto",
                                                  density: "compact",
                                                  "item-title": (item) => item.name
                                                }, null, 8, ["modelValue", "onUpdate:modelValue", "items", "item-title"])
                                              ]),
                                              _createElementVNode("td", _hoisted_77, [
                                                _createVNode(_component_oss_text_field_filled, {
                                                  "hide-details": "auto",
                                                  modelValue: props.item.vatRate,
                                                  "onUpdate:modelValue": ($event: any) => ((props.item.vatRate) = $event)
                                                }, null, 8, ["modelValue", "onUpdate:modelValue"])
                                              ]),
                                              _createElementVNode("td", _hoisted_78, [
                                                _createVNode(_component_v_select_filled, {
                                                  modelValue: 
                                                                    props.item.vatCollectionTime
                                                                ,
                                                  "onUpdate:modelValue": ($event: any) => ((
                                                                    props.item.vatCollectionTime
                                                                ) = $event),
                                                  items: _ctx.vatCollectionTimes,
                                                  "item-value": "id",
                                                  required: "",
                                                  "hide-details": "auto",
                                                  density: "compact",
                                                  "item-title": (item) => item.name
                                                }, null, 8, ["modelValue", "onUpdate:modelValue", "items", "item-title"])
                                              ]),
                                              _createElementVNode("td", _hoisted_79, [
                                                _withDirectives((_openBlock(), _createBlock(_component_v_icon, {
                                                  onClick: ($event: any) => (
                                                                    props.toggleExpand(
                                                                        props.internalItem,
                                                                    )
                                                                ),
                                                  "data-cy": 
                                                                    'BudgetFormFull-analysis-' +
                                                                    props.index
                                                                
                                                }, {
                                                  default: _withCtx(() => _cache[79] || (_cache[79] = [
                                                    _createTextVNode("$oss-analysis")
                                                  ])),
                                                  _: 2
                                                }, 1032, ["onClick", "data-cy"])), [
                                                  [_directive_tooltip, 
                                                                    'Détail de la ligne'
                                                                , "bottom"]
                                                ])
                                              ]),
                                              _createElementVNode("td", _hoisted_80, [
                                                _createVNode(_component_v_tooltip, { location: "bottom" }, {
                                                  activator: _withCtx(({ props }) => [
                                                    _createVNode(_component_v_icon, _mergeProps({
                                                      onClick: ($event: any) => {
                                                                            _ctx.activeItemType =
                                                                                'recurringCharge';
                                                                            _ctx.deleteLine(props.index);
                                                                        }
                                                    }, props, {
                                                      "data-cy": 
                                                                            'BudgetFormFull-trashEnd-' +
                                                                            props.index
                                                                        
                                                    }), {
                                                      default: _withCtx(() => _cache[80] || (_cache[80] = [
                                                        _createTextVNode("$oss-trash")
                                                      ])),
                                                      _: 2
                                                    }, 1040, ["onClick", "data-cy"])
                                                  ]),
                                                  default: _withCtx(() => [
                                                    _cache[81] || (_cache[81] = _createElementVNode("span", null, "Supprimer la ligne", -1))
                                                  ]),
                                                  _: 2
                                                }, 1024),
                                                _createVNode(_component_v_tooltip, { location: "bottom" }, {
                                                  activator: _withCtx(({ props }) => [
                                                    _createVNode(_component_v_icon, _mergeProps({
                                                      onClick: ($event: any) => (
                                                                            _ctx.reinitializeLine(
                                                                                props.index,
                                                                            )
                                                                        )
                                                    }, props), {
                                                      default: _withCtx(() => _cache[82] || (_cache[82] = [
                                                        _createTextVNode("$oss-file")
                                                      ])),
                                                      _: 2
                                                    }, 1040, ["onClick"])
                                                  ]),
                                                  default: _withCtx(() => [
                                                    _cache[83] || (_cache[83] = _createElementVNode("span", null, "Réinitialiser la ligne", -1))
                                                  ]),
                                                  _: 2
                                                }, 1024)
                                              ])
                                            ])
                                          ]),
                                          "expanded-row": _withCtx(({ columns, item }) => [
                                            _createElementVNode("td", {
                                              colspan: columns.length
                                            }, [
                                              _createVNode(_component_ChargeDetails, {
                                                charge: item,
                                                parameters: _ctx.parameters,
                                                date: _ctx.date,
                                                isDetailEditable: 
                                                                !item.activeReporting
                                                            ,
                                                onStoreActiveDetails: _cache[13] || (_cache[13] = ($event: any) => (
                                                                _ctx.onStoreActiveDetails($event)
                                                            ))
                                              }, null, 8, ["charge", "parameters", "date", "isDetailEditable"])
                                            ], 8, _hoisted_81)
                                          ]),
                                          [`body.append`]: _withCtx(({ columns }) => [
                                            _createElementVNode("tr", null, [
                                              _createElementVNode("td", {
                                                colspan: columns.length
                                              }, [
                                                _createElementVNode("div", _hoisted_83, [
                                                  _createVNode(_component_v_btn, {
                                                    rounded: "",
                                                    elevation: "0",
                                                    onClick: _cache[14] || (_cache[14] = ($event: any) => (_ctx.addCharge())),
                                                    size: "small"
                                                  }, {
                                                    default: _withCtx(() => _cache[84] || (_cache[84] = [
                                                      _createTextVNode(" Ajouter une ligne ")
                                                    ])),
                                                    _: 1
                                                  })
                                                ])
                                              ], 8, _hoisted_82)
                                            ])
                                          ]),
                                          _: 2
                                        }, 1032, ["items", "headers", "itemsPerPage", "expanded"])
                                      ]),
                                      _: 1
                                    })
                                  ]),
                                  _: 1
                                }),
                                _createVNode(_component_v_expansion_panel, { class: "py-0 my-0" }, {
                                  default: _withCtx(() => [
                                    _createVNode(_component_v_expansion_panel_title, { class: "py-0 my-0" }, {
                                      default: _withCtx(() => _cache[85] || (_cache[85] = [
                                        _createElementVNode("h3", null, "Charges fixes uniques et immobilisations", -1)
                                      ])),
                                      _: 1
                                    }),
                                    _createVNode(_component_v_expansion_panel_text, { class: "py-0 my-0" }, {
                                      default: _withCtx(() => [
                                        _createVNode(_component_v_data_table, {
                                          items: _ctx.formBff.charges.uniqueCharges,
                                          headers: _ctx.investmentsHeaders,
                                          itemsPerPage: _ctx.formBff.charges.uniqueCharges.length,
                                          "hide-default-footer": "",
                                          class: "table",
                                          density: "compact"
                                        }, {
                                          item: _withCtx((props) => [
                                            _createElementVNode("tr", _hoisted_84, [
                                              (_ctx.selectedPartition)
                                                ? (_openBlock(), _createElementBlock("td", _hoisted_85, [
                                                    _createVNode(_component_v_combobox_filled, {
                                                      modelValue: props.item.tag,
                                                      "onUpdate:modelValue": ($event: any) => ((props.item.tag) = $event),
                                                      items: _ctx.tagsSelection,
                                                      "item-value": "id",
                                                      dense: "",
                                                      "hide-details": "auto",
                                                      onChange: ($event: any) => (
                                                                    _ctx.updateTagsSelection(props.item)
                                                                ),
                                                      "item-title": (item) => item.name
                                                    }, null, 8, ["modelValue", "onUpdate:modelValue", "items", "onChange", "item-title"])
                                                  ]))
                                                : _createCommentVNode("", true),
                                              _createElementVNode("td", _hoisted_86, [
                                                _createVNode(_component_v_combobox_filled, {
                                                  modelValue: props.item.title,
                                                  "onUpdate:modelValue": ($event: any) => ((props.item.title) = $event),
                                                  items: _ctx.preSelectedExpenses,
                                                  dense: "",
                                                  "hide-details": "auto",
                                                  onChange: ($event: any) => (
                                                                    _ctx.updateDefaultNature(props.item)
                                                                )
                                                }, null, 8, ["modelValue", "onUpdate:modelValue", "items", "onChange"])
                                              ]),
                                              _createElementVNode("td", _hoisted_87, [
                                                _createVNode(_component_oss_date_picker_filled, {
                                                  date: 
                                                                    _ctx.transformGapToDate(
                                                                        props.item.monthGap,
                                                                    )
                                                                ,
                                                  onChangeDate: _ctx.assignItemDate,
                                                  onClose: ($event: any) => (
                                                                    _ctx.transformDateToGap(props.item)
                                                                ),
                                                  type: "month",
                                                  format: "MM-YYYY",
                                                  "text-field-readonly": false,
                                                  "hide-details": "auto",
                                                  density: "compact"
                                                }, null, 8, ["date", "onChangeDate", "onClose"])
                                              ]),
                                              _createElementVNode("td", _hoisted_88, [
                                                _createVNode(_component_oss_text_field_filled, {
                                                  "hide-details": "auto",
                                                  dense: "",
                                                  modelValue: props.item.amount,
                                                  "onUpdate:modelValue": ($event: any) => ((props.item.amount) = $event)
                                                }, null, 8, ["modelValue", "onUpdate:modelValue"])
                                              ]),
                                              _createElementVNode("td", _hoisted_89, [
                                                _createVNode(_component_v_menu, {
                                                  "close-on-content-click": false,
                                                  "offset-y": "",
                                                  style: {"max-width":"500px"}
                                                }, {
                                                  activator: _withCtx(({ props }) => [
                                                    _createVNode(_component_v_btn, _normalizeProps(_guardReactiveProps(props)), {
                                                      default: _withCtx(() => _cache[86] || (_cache[86] = [
                                                        _createTextVNode("Détail")
                                                      ])),
                                                      _: 2
                                                    }, 1040)
                                                  ]),
                                                  default: _withCtx(() => [
                                                    _createVNode(_component_v_card, { class: "pa-2 ma-2 elevation-0" }, {
                                                      default: _withCtx(() => [
                                                        _createVNode(_component_v_row, { "no-gutter": "" }, {
                                                          default: _withCtx(() => [
                                                            _createVNode(_component_v_col, { cols: "5" }, {
                                                              default: _withCtx(() => _cache[87] || (_cache[87] = [
                                                                _createTextVNode("Type : ")
                                                              ])),
                                                              _: 1
                                                            }),
                                                            _createVNode(_component_v_col, { cols: "7" }, {
                                                              default: _withCtx(() => [
                                                                _createVNode(_component_v_select_filled, {
                                                                  modelValue: 
                                                                                    props.item
                                                                                        .staggering
                                                                                ,
                                                                  "onUpdate:modelValue": ($event: any) => ((
                                                                                    props.item
                                                                                        .staggering
                                                                                ) = $event),
                                                                  items: 
                                                                                    _ctx.investmentStaggeringTypes
                                                                                ,
                                                                  "hide-details": "auto",
                                                                  density: "compact"
                                                                }, null, 8, ["modelValue", "onUpdate:modelValue", "items"])
                                                              ]),
                                                              _: 2
                                                            }, 1024)
                                                          ]),
                                                          _: 2
                                                        }, 1024),
                                                        _createVNode(_component_v_row, { "no-gutter": "" }, {
                                                          default: _withCtx(() => [
                                                            _createVNode(_component_v_col, { cols: "5" }, {
                                                              default: _withCtx(() => _cache[88] || (_cache[88] = [
                                                                _createTextVNode("Différé : ")
                                                              ])),
                                                              _: 1
                                                            }),
                                                            _createVNode(_component_v_col, { cols: "7" }, {
                                                              default: _withCtx(() => [
                                                                _createVNode(_component_v_select_filled, {
                                                                  modelValue: 
                                                                                    props.item
                                                                                        .staggeringOffset
                                                                                ,
                                                                  "onUpdate:modelValue": ($event: any) => ((
                                                                                    props.item
                                                                                        .staggeringOffset
                                                                                ) = $event),
                                                                  items: 
                                                                                    _ctx.offsetDelays
                                                                                ,
                                                                  "item-value": "id",
                                                                  "hide-details": "auto",
                                                                  density: "compact",
                                                                  "item-title": 
                                                                                    (item) =>
                                                                                        item.name
                                                                                
                                                                }, null, 8, ["modelValue", "onUpdate:modelValue", "items", "item-title"])
                                                              ]),
                                                              _: 2
                                                            }, 1024)
                                                          ]),
                                                          _: 2
                                                        }, 1024),
                                                        (
                                                                            props.item
                                                                                .staggering ===
                                                                            'Etalement'
                                                                        )
                                                          ? (_openBlock(), _createBlock(_component_v_row, {
                                                              key: 0,
                                                              "no-gutter": ""
                                                            }, {
                                                              default: _withCtx(() => [
                                                                _createVNode(_component_v_col, { cols: "5" }, {
                                                                  default: _withCtx(() => _cache[89] || (_cache[89] = [
                                                                    _createTextVNode("Durée : ")
                                                                  ])),
                                                                  _: 1
                                                                }),
                                                                _createVNode(_component_v_col, { cols: "7" }, {
                                                                  default: _withCtx(() => [
                                                                    _createVNode(_component_v_select_filled, {
                                                                      modelValue: 
                                                                                    props.item
                                                                                        .staggeringDuration
                                                                                ,
                                                                      "onUpdate:modelValue": [($event: any) => ((
                                                                                    props.item
                                                                                        .staggeringDuration
                                                                                ) = $event), ($event: any) => (
                                                                                    _ctx.updateDefaultAmortizationLaw(
                                                                                        props.item,
                                                                                    )
                                                                                )],
                                                                      items: 
                                                                                    _ctx.staggeringDurationDelays
                                                                                ,
                                                                      "item-value": "id",
                                                                      "hide-details": "auto",
                                                                      density: "compact",
                                                                      "item-title": 
                                                                                    (item) =>
                                                                                        item.name
                                                                                
                                                                    }, null, 8, ["modelValue", "onUpdate:modelValue", "items", "item-title"])
                                                                  ]),
                                                                  _: 2
                                                                }, 1024)
                                                              ]),
                                                              _: 2
                                                            }, 1024))
                                                          : _createCommentVNode("", true),
                                                        (
                                                                            props.item
                                                                                .staggering ===
                                                                            'Amortissement'
                                                                        )
                                                          ? (_openBlock(), _createBlock(_component_v_row, {
                                                              key: 1,
                                                              "no-gutter": ""
                                                            }, {
                                                              default: _withCtx(() => [
                                                                _createVNode(_component_v_col, { cols: "5" }, {
                                                                  default: _withCtx(() => _cache[90] || (_cache[90] = [
                                                                    _createTextVNode("Durée : ")
                                                                  ])),
                                                                  _: 1
                                                                }),
                                                                _createVNode(_component_v_col, { cols: "7" }, {
                                                                  default: _withCtx(() => [
                                                                    _createVNode(_component_v_select_filled, {
                                                                      modelValue: 
                                                                                    props.item
                                                                                        .staggeringDuration
                                                                                ,
                                                                      "onUpdate:modelValue": [($event: any) => ((
                                                                                    props.item
                                                                                        .staggeringDuration
                                                                                ) = $event), ($event: any) => (
                                                                                    _ctx.updateDefaultAmortizationLaw(
                                                                                        props.item,
                                                                                    )
                                                                                )],
                                                                      items: 
                                                                                    _ctx.durationDelays
                                                                                ,
                                                                      "item-value": "id",
                                                                      "hide-details": "auto",
                                                                      density: "compact",
                                                                      "item-title": 
                                                                                    (item) =>
                                                                                        item.name
                                                                                
                                                                    }, null, 8, ["modelValue", "onUpdate:modelValue", "items", "item-title"])
                                                                  ]),
                                                                  _: 2
                                                                }, 1024)
                                                              ]),
                                                              _: 2
                                                            }, 1024))
                                                          : _createCommentVNode("", true),
                                                        (
                                                                            props.item
                                                                                .staggering ===
                                                                            'Amortissement'
                                                                        )
                                                          ? (_openBlock(), _createBlock(_component_v_row, {
                                                              key: 2,
                                                              "no-gutter": ""
                                                            }, {
                                                              default: _withCtx(() => [
                                                                _createVNode(_component_v_col, { cols: "5" }, {
                                                                  default: _withCtx(() => _cache[91] || (_cache[91] = [
                                                                    _createTextVNode("Loi d'amortissement : ")
                                                                  ])),
                                                                  _: 1
                                                                }),
                                                                _createVNode(_component_v_col, { cols: "7" }, {
                                                                  default: _withCtx(() => [
                                                                    _createVNode(_component_v_select_filled, {
                                                                      modelValue: 
                                                                                    props.item
                                                                                        .amortizationLaw
                                                                                ,
                                                                      "onUpdate:modelValue": ($event: any) => ((
                                                                                    props.item
                                                                                        .amortizationLaw
                                                                                ) = $event),
                                                                      items: 
                                                                                    _ctx.investmentsAmortizationLaws
                                                                                ,
                                                                      "item-value": "id",
                                                                      "hide-details": "auto",
                                                                      density: "compact",
                                                                      "item-title": 
                                                                                    (item) =>
                                                                                        item.name
                                                                                
                                                                    }, null, 8, ["modelValue", "onUpdate:modelValue", "items", "item-title"])
                                                                  ]),
                                                                  _: 2
                                                                }, 1024)
                                                              ]),
                                                              _: 2
                                                            }, 1024))
                                                          : _createCommentVNode("", true)
                                                      ]),
                                                      _: 2
                                                    }, 1024)
                                                  ]),
                                                  _: 2
                                                }, 1024)
                                              ]),
                                              _createElementVNode("td", _hoisted_90, [
                                                _createVNode(_component_oss_text_field_filled, {
                                                  "hide-details": "auto",
                                                  min: 1,
                                                  dense: "",
                                                  modelValue: props.item.paymentNumber,
                                                  "onUpdate:modelValue": ($event: any) => ((props.item.paymentNumber) = $event)
                                                }, null, 8, ["modelValue", "onUpdate:modelValue"])
                                              ]),
                                              _createElementVNode("td", _hoisted_91, [
                                                _createVNode(_component_v_select_filled, {
                                                  modelValue: props.item.paymentSpacing,
                                                  "onUpdate:modelValue": ($event: any) => ((props.item.paymentSpacing) = $event),
                                                  items: _ctx.uniqueChargePaymentSpacing,
                                                  "item-value": "id",
                                                  "hide-details": "auto",
                                                  density: "compact",
                                                  "item-title": (item) => item.name
                                                }, null, 8, ["modelValue", "onUpdate:modelValue", "items", "item-title"])
                                              ]),
                                              _createElementVNode("td", _hoisted_92, [
                                                _createVNode(_component_oss_text_field_filled, {
                                                  "hide-details": "auto",
                                                  dense: "",
                                                  modelValue: props.item.vatRate,
                                                  "onUpdate:modelValue": ($event: any) => ((props.item.vatRate) = $event)
                                                }, null, 8, ["modelValue", "onUpdate:modelValue"])
                                              ]),
                                              _createElementVNode("td", _hoisted_93, [
                                                _createVNode(_component_v_select_filled, {
                                                  modelValue: 
                                                                    props.item.vatCollectionTime
                                                                ,
                                                  "onUpdate:modelValue": ($event: any) => ((
                                                                    props.item.vatCollectionTime
                                                                ) = $event),
                                                  items: _ctx.vatCollectionTimes,
                                                  "item-value": "id",
                                                  "hide-details": "auto",
                                                  density: "compact",
                                                  "item-title": (item) => item.name
                                                }, null, 8, ["modelValue", "onUpdate:modelValue", "items", "item-title"])
                                              ]),
                                              _createElementVNode("td", _hoisted_94, [
                                                _createVNode(_component_v_tooltip, { location: "bottom" }, {
                                                  activator: _withCtx(({ props }) => [
                                                    _createVNode(_component_v_icon, _mergeProps({
                                                      onClick: ($event: any) => {
                                                                            _ctx.activeItemType =
                                                                                'uniqueCharge';
                                                                            _ctx.deleteLine(props.index);
                                                                        }
                                                    }, props), {
                                                      default: _withCtx(() => _cache[92] || (_cache[92] = [
                                                        _createTextVNode("$oss-trash")
                                                      ])),
                                                      _: 2
                                                    }, 1040, ["onClick"])
                                                  ]),
                                                  default: _withCtx(() => [
                                                    _cache[93] || (_cache[93] = _createElementVNode("span", null, "Supprimer la ligne", -1))
                                                  ]),
                                                  _: 2
                                                }, 1024),
                                                _createVNode(_component_v_tooltip, { location: "bottom" }, {
                                                  activator: _withCtx(({ props }) => [
                                                    _createVNode(_component_v_icon, _mergeProps({
                                                      onClick: ($event: any) => (
                                                                            _ctx.reinitializeLine(
                                                                                props.index,
                                                                            )
                                                                        )
                                                    }, props), {
                                                      default: _withCtx(() => _cache[94] || (_cache[94] = [
                                                        _createTextVNode("$oss-file")
                                                      ])),
                                                      _: 2
                                                    }, 1040, ["onClick"])
                                                  ]),
                                                  default: _withCtx(() => [
                                                    _cache[95] || (_cache[95] = _createElementVNode("span", null, "Réinitialiser la ligne", -1))
                                                  ]),
                                                  _: 2
                                                }, 1024)
                                              ])
                                            ])
                                          ]),
                                          [`body.append`]: _withCtx(({ columns }) => [
                                            _createElementVNode("tr", null, [
                                              _createElementVNode("td", {
                                                colspan: columns.length
                                              }, [
                                                _createElementVNode("div", _hoisted_96, [
                                                  _createVNode(_component_v_btn, {
                                                    rounded: "",
                                                    elevation: "0",
                                                    onClick: _cache[16] || (_cache[16] = ($event: any) => (_ctx.addInvestment())),
                                                    size: "small"
                                                  }, {
                                                    default: _withCtx(() => _cache[96] || (_cache[96] = [
                                                      _createTextVNode(" Ajouter une ligne ")
                                                    ])),
                                                    _: 1
                                                  })
                                                ])
                                              ], 8, _hoisted_95)
                                            ])
                                          ]),
                                          _: 2
                                        }, 1032, ["items", "headers", "itemsPerPage"])
                                      ]),
                                      _: 1
                                    })
                                  ]),
                                  _: 1
                                })
                              ]),
                              _: 1
                            }, 8, ["modelValue"])
                          ]),
                          _: 1
                        }),
                        _createVNode(_component_v_card_actions, { class: "d-flex justify-center align-end" }, {
                          default: _withCtx(() => [
                            _createVNode(_component_v_btn_prev, {
                              onClick: _cache[18] || (_cache[18] = ($event: any) => (_ctx.previous()))
                            }),
                            _createVNode(_component_v_btn_next, {
                              onClick: _cache[19] || (_cache[19] = ($event: any) => (_ctx.next()))
                            })
                          ]),
                          _: 1
                        })
                      ]),
                      _: 1
                    })
                  ]),
                  _: 1
                }),
                _createVNode(_component_v_window_item, { value: "4" }, {
                  default: _withCtx(() => [
                    _createVNode(_component_v_card, { style: {"box-shadow":"none"} }, {
                      default: _withCtx(() => [
                        _createVNode(_component_v_card_text, { stye: "height:65vh;" }, {
                          default: _withCtx(() => [
                            _createVNode(_component_v_data_table, {
                              items: _ctx.formBff.staff,
                              headers: _ctx.reactiveStaffHeaders,
                              itemsPerPage: _ctx.formBff.staff.length,
                              "single-expand": false,
                              expanded: _ctx.staffExpanded,
                              "onUpdate:expanded": _cache[22] || (_cache[22] = ($event: any) => ((_ctx.staffExpanded) = $event)),
                              "item-key": "title",
                              "show-expand": "",
                              "hide-default-footer": "",
                              class: "table"
                            }, {
                              item: _withCtx((props) => [
                                _createElementVNode("tr", null, [
                                  (_ctx.selectedPartition)
                                    ? (_openBlock(), _createElementBlock("td", _hoisted_97, [
                                        _createVNode(_component_v_combobox_filled, {
                                          modelValue: props.item.tag,
                                          "onUpdate:modelValue": ($event: any) => ((props.item.tag) = $event),
                                          items: _ctx.tagsSelection,
                                          "item-value": "id",
                                          dense: "",
                                          "hide-details": "auto",
                                          onChange: ($event: any) => (_ctx.updateTagsSelection(props.item)),
                                          "item-title": (item) => item.name
                                        }, null, 8, ["modelValue", "onUpdate:modelValue", "items", "onChange", "item-title"])
                                      ]))
                                    : _createCommentVNode("", true),
                                  _createElementVNode("td", _hoisted_98, [
                                    _createVNode(_component_v_checkbox, {
                                      modelValue: props.item.isBoss,
                                      "onUpdate:modelValue": [($event: any) => ((props.item.isBoss) = $event), _ctx.reactiveStaffHeaders],
                                      ripple: false
                                    }, null, 8, ["modelValue", "onUpdate:modelValue"])
                                  ]),
                                  _createElementVNode("td", _hoisted_99, [
                                    _createVNode(_component_v_text_field_filled, {
                                      modelValue: props.item.title,
                                      "onUpdate:modelValue": ($event: any) => ((props.item.title) = $event),
                                      "hide-details": "auto",
                                      "data-cy": "BudgetFormFull-libelle",
                                      density: "compact"
                                    }, null, 8, ["modelValue", "onUpdate:modelValue"])
                                  ]),
                                  _createElementVNode("td", _hoisted_100, [
                                    _createVNode(_component_oss_text_field_filled, {
                                      "hide-details": "auto",
                                      onChange: ($event: any) => {
                                                        _ctx.updateFirstYearTotalGrossSalary(props.item);
                                                        _ctx.buildStaffDefaultDetails(props.item);
                                                    },
                                      "data-cy": "BudgetFormFull-effectif",
                                      modelValue: props.item.number,
                                      "onUpdate:modelValue": ($event: any) => ((props.item.number) = $event)
                                    }, null, 8, ["onChange", "modelValue", "onUpdate:modelValue"])
                                  ]),
                                  _createElementVNode("td", _hoisted_101, [
                                    _createVNode(_component_oss_text_field_filled, {
                                      "hide-details": "auto",
                                      onChange: ($event: any) => {
                                                        _ctx.updateFirstYearTotalGrossSalary(props.item);
                                                        _ctx.buildStaffDefaultDetails(props.item);
                                                    },
                                      "data-cy": "BudgetFormFull-indifiduelAnnuelBrut",
                                      modelValue: props.item.years[0].individualAmount,
                                      "onUpdate:modelValue": ($event: any) => ((props.item.years[0].individualAmount) = $event)
                                    }, null, 8, ["onChange", "modelValue", "onUpdate:modelValue"])
                                  ]),
                                  _createElementVNode("td", _hoisted_102, [
                                    _createVNode(_component_oss_text_field_filled, {
                                      "hide-details": "auto",
                                      onChange: ($event: any) => {
                                                        _ctx.updateFirstYearMonthlyGrossSalaryAndAmounts(
                                                            props.item,
                                                        );
                                                        _ctx.buildStaffDefaultDetails(props.item);
                                                    },
                                      disabled: "",
                                      modelValue: props.item.years[0].totalAmount,
                                      "onUpdate:modelValue": ($event: any) => ((props.item.years[0].totalAmount) = $event)
                                    }, null, 8, ["onChange", "modelValue", "onUpdate:modelValue"])
                                  ]),
                                  (props.item.years.length > 1)
                                    ? (_openBlock(), _createElementBlock("td", _hoisted_103, [
                                        _createVNode(_component_oss_text_field_filled, {
                                          "hide-details": "auto",
                                          onChange: ($event: any) => {
                                                        _ctx.updateStaffFurtherPercentages(props.item);
                                                        _ctx.buildStaffDefaultDetails(props.item);
                                                    },
                                          "data-cy": "BudgetFormFull-cotisationsSalarial",
                                          modelValue: 
                                                        props.item.years[1].evolutionPercentage
                                                    ,
                                          "onUpdate:modelValue": ($event: any) => ((
                                                        props.item.years[1].evolutionPercentage
                                                    ) = $event)
                                        }, null, 8, ["onChange", "modelValue", "onUpdate:modelValue"])
                                      ]))
                                    : _createCommentVNode("", true),
                                  (!_ctx.areAllSalariesBosses())
                                    ? (_openBlock(), _createElementBlock("td", _hoisted_104, [
                                        _createVNode(_component_oss_text_field_filled, {
                                          disabled: props.item.isBoss,
                                          "hide-details": "auto",
                                          "data-cy": "BudgetFormFull-cotisationPatronales",
                                          modelValue: props.item.wagesTax,
                                          "onUpdate:modelValue": ($event: any) => ((props.item.wagesTax) = $event)
                                        }, null, 8, ["disabled", "modelValue", "onUpdate:modelValue"])
                                      ]))
                                    : _createCommentVNode("", true),
                                  (!props.item.isBoss)
                                    ? (_openBlock(), _createElementBlock("td", _hoisted_105, [
                                        _createVNode(_component_oss_text_field_filled, {
                                          "hide-details": "auto",
                                          "data-cy": "test4",
                                          modelValue: props.item.employerTax,
                                          "onUpdate:modelValue": ($event: any) => ((props.item.employerTax) = $event)
                                        }, null, 8, ["modelValue", "onUpdate:modelValue"])
                                      ]))
                                    : _createCommentVNode("", true),
                                  (props.item.isBoss)
                                    ? (_openBlock(), _createElementBlock("td", _hoisted_106, [
                                        _createVNode(_component_oss_text_field_filled, {
                                          "hide-details": "auto",
                                          "data-cy": "test5",
                                          modelValue: props.item.globalTax,
                                          "onUpdate:modelValue": ($event: any) => ((props.item.globalTax) = $event)
                                        }, null, 8, ["modelValue", "onUpdate:modelValue"])
                                      ]))
                                    : _createCommentVNode("", true),
                                  _createElementVNode("td", _hoisted_107, [
                                    _withDirectives((_openBlock(), _createBlock(_component_v_icon, {
                                      onClick: ($event: any) => (props.toggleExpand(props.internalItem)),
                                      "data-cy": "BudgetFormFull-datail"
                                    }, {
                                      default: _withCtx(() => _cache[97] || (_cache[97] = [
                                        _createTextVNode("$oss-analysis")
                                      ])),
                                      _: 2
                                    }, 1032, ["onClick"])), [
                                      [_directive_tooltip, 'Détail de la ligne', "bottom"]
                                    ])
                                  ]),
                                  _createElementVNode("td", _hoisted_108, [
                                    _createVNode(_component_v_tooltip, { location: "bottom" }, {
                                      activator: _withCtx(({ props }) => [
                                        _createVNode(_component_v_icon, _mergeProps({
                                          onClick: ($event: any) => {
                                                                _ctx.activeItemType = 'staff';
                                                                _ctx.deleteLine(props.index);
                                                            }
                                        }, props), {
                                          default: _withCtx(() => _cache[98] || (_cache[98] = [
                                            _createTextVNode("$oss-trash")
                                          ])),
                                          _: 2
                                        }, 1040, ["onClick"])
                                      ]),
                                      default: _withCtx(() => [
                                        _cache[99] || (_cache[99] = _createElementVNode("span", null, "Supprimer la ligne", -1))
                                      ]),
                                      _: 2
                                    }, 1024),
                                    _createVNode(_component_v_tooltip, { location: "bottom" }, {
                                      activator: _withCtx(({ props: tooltip }) => [
                                        _createVNode(_component_v_icon, _mergeProps({
                                          onClick: ($event: any) => (_ctx.reinitializeLine(props.index))
                                        }, props), {
                                          default: _withCtx(() => _cache[100] || (_cache[100] = [
                                            _createTextVNode("$oss-file")
                                          ])),
                                          _: 2
                                        }, 1040, ["onClick"])
                                      ]),
                                      default: _withCtx(() => [
                                        _cache[101] || (_cache[101] = _createElementVNode("span", null, "Réinitialiser la ligne", -1))
                                      ]),
                                      _: 2
                                    }, 1024)
                                  ])
                                ])
                              ]),
                              "expanded-row": _withCtx(({ columns, item }) => [
                                _createElementVNode("td", {
                                  colspan: columns.length
                                }, [
                                  _createVNode(_component_StaffDetails, {
                                    staff: item,
                                    parameters: _ctx.parameters,
                                    date: _ctx.date,
                                    onStoreActiveDetails: _cache[20] || (_cache[20] = ($event: any) => (_ctx.onStoreActiveDetails($event)))
                                  }, null, 8, ["staff", "parameters", "date"])
                                ], 8, _hoisted_109)
                              ]),
                              [`body.append`]: _withCtx(({ columns }) => [
                                _createElementVNode("tr", null, [
                                  _createElementVNode("td", {
                                    colspan: columns.length
                                  }, [
                                    _createElementVNode("div", _hoisted_111, [
                                      _createVNode(_component_v_btn, {
                                        rounded: "",
                                        elevation: "0",
                                        onClick: _cache[21] || (_cache[21] = ($event: any) => (_ctx.addStaff())),
                                        size: "small"
                                      }, {
                                        default: _withCtx(() => _cache[102] || (_cache[102] = [
                                          _createTextVNode(" Ajouter une ligne ")
                                        ])),
                                        _: 1
                                      })
                                    ])
                                  ], 8, _hoisted_110)
                                ])
                              ]),
                              _: 2
                            }, 1032, ["items", "headers", "itemsPerPage", "expanded"])
                          ]),
                          _: 1
                        }),
                        _createVNode(_component_v_card_actions, { class: "d-flex justify-center align-end" }, {
                          default: _withCtx(() => [
                            _createVNode(_component_v_btn_prev, {
                              onClick: _cache[23] || (_cache[23] = ($event: any) => (_ctx.previous()))
                            }),
                            _createVNode(_component_v_btn_next, {
                              onClick: _cache[24] || (_cache[24] = ($event: any) => (_ctx.next()))
                            })
                          ]),
                          _: 1
                        })
                      ]),
                      _: 1
                    })
                  ]),
                  _: 1
                })
              ]),
              _: 1
            }, 8, ["modelValue"])
          ])
        ]),
        _: 1
      }),
      _createVNode(_component_v_snackbar, {
        modelValue: _ctx.displayFillingOptions,
        "onUpdate:modelValue": _cache[26] || (_cache[26] = ($event: any) => ((_ctx.displayFillingOptions) = $event)),
        timeout: _ctx.timeout,
        color: "primary"
      }, {
        actions: _withCtx(() => [
          _createVNode(_component_v_btn, {
            onClick: _ctx.onValueReported,
            variant: "text"
          }, {
            default: _withCtx(() => _cache[103] || (_cache[103] = [
              _createTextVNode(" Reporter ")
            ])),
            _: 1
          }, 8, ["onClick"])
        ]),
        default: _withCtx(() => [
          _cache[104] || (_cache[104] = _createTextVNode(" Voulez-vous reporter la valeur que vous venez de saisir jusqu'à la fin de l'exercice ? "))
        ]),
        _: 1
      }, 8, ["modelValue", "timeout"]),
      _createVNode(_component_oss_dialog, {
        modelValue: _ctx.displayStaggeringDialog,
        "onUpdate:modelValue": _cache[38] || (_cache[38] = ($event: any) => ((_ctx.displayStaggeringDialog) = $event)),
        onValid: _ctx.validStaggering,
        onClose: _ctx.closeStaggering,
        validTitle: "Reporter la valeur",
        "valid-loading": _ctx.staggeringLoading,
        minWidth: _ctx.width,
        height: _ctx.height,
        "min-height": "80vh",
        "valid-disabled": !_ctx.finalStepCompletedStaggering
      }, {
        default: _withCtx(() => [
          _createVNode(_component_v_card, null, {
            default: _withCtx(() => [
              _createVNode(_component_v_card_title, null, {
                default: _withCtx(() => [
                  _createTextVNode(_toDisplayString(_ctx.stepTitle), 1)
                ]),
                _: 1
              }),
              _createVNode(_component_v_window, {
                modelValue: _ctx.staggeringStep,
                "onUpdate:modelValue": _cache[37] || (_cache[37] = ($event: any) => ((_ctx.staggeringStep) = $event)),
                touchless: "",
                class: "elevation-0",
                style: {"background":"transparent"}
              }, {
                default: _withCtx(() => [
                  _createVNode(_component_v_window_item, { value: 1 }, {
                    default: _withCtx(() => [
                      _createVNode(_component_v_card_text, { class: "py-0" }, {
                        default: _withCtx(() => [
                          _createVNode(_component_v_list, {
                            subheader: "",
                            lines: "two"
                          }, {
                            default: _withCtx(() => [
                              _createVNode(_component_v_list_item, {
                                class: "mb-2 rounded-lg",
                                onClick: _cache[27] || (_cache[27] = ($event: any) => {
                                        _ctx.staggeringModification = 'equal';
                                        _ctx.staggeringStep++;
                                    })
                              }, {
                                append: _withCtx(() => [
                                  _createVNode(_component_v_btn_next)
                                ]),
                                default: _withCtx(() => [
                                  _createVNode(_component_v_list_item_title, null, {
                                    default: _withCtx(() => _cache[105] || (_cache[105] = [
                                      _createTextVNode("Reporter le montant à l'identique")
                                    ])),
                                    _: 1
                                  }),
                                  _createVNode(_component_v_list_item_subtitle, null, {
                                    default: _withCtx(() => _cache[106] || (_cache[106] = [
                                      _createTextVNode("Toutes les cases situées dans la période de report porteront la même valeur")
                                    ])),
                                    _: 1
                                  })
                                ]),
                                _: 1
                              }),
                              _createVNode(_component_v_list_item, {
                                class: "mb-2 rounded-lg",
                                onClick: _cache[28] || (_cache[28] = ($event: any) => {
                                        _ctx.staggeringModification = 'percentage';
                                        _ctx.staggeringStep++;
                                    })
                              }, {
                                append: _withCtx(() => [
                                  _createVNode(_component_v_btn_next)
                                ]),
                                default: _withCtx(() => [
                                  _createVNode(_component_v_list_item_title, null, {
                                    default: _withCtx(() => _cache[107] || (_cache[107] = [
                                      _createTextVNode("Reporter le montant en lui appliquant un pourcentage")
                                    ])),
                                    _: 1
                                  }),
                                  _createVNode(_component_v_list_item_subtitle, null, {
                                    default: _withCtx(() => _cache[108] || (_cache[108] = [
                                      _createTextVNode("Un pourcentage est appliqué au montant à reporter tous les x mois.")
                                    ])),
                                    _: 1
                                  })
                                ]),
                                _: 1
                              }),
                              _createVNode(_component_v_list_item, {
                                class: "mb-2 rounded-lg",
                                onClick: _cache[29] || (_cache[29] = ($event: any) => {
                                        _ctx.staggeringModification = 'amount';
                                        _ctx.staggeringStep++;
                                    })
                              }, {
                                append: _withCtx(() => [
                                  _createVNode(_component_v_btn_next)
                                ]),
                                default: _withCtx(() => [
                                  _createVNode(_component_v_list_item_title, null, {
                                    default: _withCtx(() => _cache[109] || (_cache[109] = [
                                      _createTextVNode("Reporter le montant en lui ajoutant ou soustrayant un montant")
                                    ])),
                                    _: 1
                                  }),
                                  _createVNode(_component_v_list_item_subtitle, null, {
                                    default: _withCtx(() => _cache[110] || (_cache[110] = [
                                      _createTextVNode("Cette addition ou soustraction est appliquée au montant à reporter tous les x mois.")
                                    ])),
                                    _: 1
                                  })
                                ]),
                                _: 1
                              })
                            ]),
                            _: 1
                          })
                        ]),
                        _: 1
                      })
                    ]),
                    _: 1
                  }),
                  _createVNode(_component_v_window_item, { value: 2 }, {
                    default: _withCtx(() => [
                      _createVNode(_component_v_card_text, { class: "py-0" }, {
                        default: _withCtx(() => [
                          _createVNode(_component_v_list, {
                            subheader: "",
                            lines: "two"
                          }, {
                            default: _withCtx(() => [
                              _createVNode(_component_v_list_item, {
                                class: "mb-2 rounded-lg",
                                onClick: _cache[30] || (_cache[30] = ($event: any) => {
                                        _ctx.staggeringPeriod = 'exercise';
                                        _ctx.staggeringStep++;
                                    })
                              }, {
                                append: _withCtx(() => [
                                  _createVNode(_component_v_btn_next)
                                ]),
                                default: _withCtx(() => [
                                  _createVNode(_component_v_list_item_title, null, {
                                    default: _withCtx(() => _cache[111] || (_cache[111] = [
                                      _createTextVNode("Reporter le montant jusqu'à la fin de l'exercice sélectionné")
                                    ])),
                                    _: 1
                                  }),
                                  _createVNode(_component_v_list_item_subtitle, null, {
                                    default: _withCtx(() => _cache[112] || (_cache[112] = [
                                      _createTextVNode("Aucun autre exercice ne sera modifié.")
                                    ])),
                                    _: 1
                                  })
                                ]),
                                _: 1
                              }),
                              _createVNode(_component_v_list_item, {
                                class: "mb-2 rounded-lg",
                                onClick: _cache[31] || (_cache[31] = ($event: any) => {
                                        _ctx.staggeringPeriod = 'budget';
                                        _ctx.staggeringStep++;
                                    })
                              }, {
                                append: _withCtx(() => [
                                  _createVNode(_component_v_btn_next)
                                ]),
                                default: _withCtx(() => [
                                  _createVNode(_component_v_list_item_title, null, {
                                    default: _withCtx(() => _cache[113] || (_cache[113] = [
                                      _createTextVNode("Reporter le montant jusqu'à la fin du budget")
                                    ])),
                                    _: 1
                                  }),
                                  _createVNode(_component_v_list_item_subtitle, null, {
                                    default: _withCtx(() => _cache[114] || (_cache[114] = [
                                      _createTextVNode("La modification sera appliquée sur l'exercice sélectionné et tous les exercices qui lui sont postérieurs.")
                                    ])),
                                    _: 1
                                  })
                                ]),
                                _: 1
                              }),
                              _createVNode(_component_v_list_item, {
                                class: "mb-2 rounded-lg",
                                onClick: _cache[32] || (_cache[32] = ($event: any) => {
                                        _ctx.staggeringPeriod = 'custom';
                                        _ctx.staggeringStep++;
                                    })
                              }, {
                                append: _withCtx(() => [
                                  _createVNode(_component_v_btn_next)
                                ]),
                                default: _withCtx(() => [
                                  _createVNode(_component_v_list_item_title, null, {
                                    default: _withCtx(() => _cache[115] || (_cache[115] = [
                                      _createTextVNode("Reporter le montant jusqu'à une date précise")
                                    ])),
                                    _: 1
                                  }),
                                  _createVNode(_component_v_list_item_subtitle, null, {
                                    default: _withCtx(() => _cache[116] || (_cache[116] = [
                                      _createTextVNode("La modification sera appliquée sur tous les mois situé entre le mois modifié et la date de fin de report choisie.")
                                    ])),
                                    _: 1
                                  })
                                ]),
                                _: 1
                              })
                            ]),
                            _: 1
                          })
                        ]),
                        _: 1
                      })
                    ]),
                    _: 1
                  }),
                  _createVNode(_component_v_window_item, { value: 3 }, {
                    default: _withCtx(() => [
                      _createVNode(_component_v_card_text, { class: "py-0" }, {
                        default: _withCtx(() => [
                          _createVNode(_component_v_row, { "no-gutters": "" }, {
                            default: _withCtx(() => [
                              (_ctx.staggeringPeriod === 'custom')
                                ? (_openBlock(), _createBlock(_component_v_col, {
                                    key: 0,
                                    cols: "6",
                                    class: "d-flex mb-2"
                                  }, {
                                    default: _withCtx(() => _cache[117] || (_cache[117] = [
                                      _createElementVNode("h4", null, "Sélection de la date de fin de report :", -1)
                                    ])),
                                    _: 1
                                  }))
                                : _createCommentVNode("", true),
                              (_ctx.staggeringPeriod === 'custom')
                                ? (_openBlock(), _createBlock(_component_v_col, {
                                    key: 1,
                                    cols: "6",
                                    class: "d-flex mb-2"
                                  }, {
                                    default: _withCtx(() => [
                                      _createVNode(_component_oss_date_picker_filled, {
                                        modelValue: _ctx.staggeringEndDate,
                                        "onUpdate:modelValue": _cache[33] || (_cache[33] = ($event: any) => ((_ctx.staggeringEndDate) = $event)),
                                        type: "month",
                                        format: "MM-YYYY",
                                        "text-field-readonly": false,
                                        "hide-details": "auto"
                                      }, null, 8, ["modelValue"])
                                    ]),
                                    _: 1
                                  }))
                                : _createCommentVNode("", true),
                              (_ctx.staggeringModification !== 'equal')
                                ? (_openBlock(), _createBlock(_component_v_col, {
                                    key: 2,
                                    cols: "6",
                                    class: "d-flex mb-2"
                                  }, {
                                    default: _withCtx(() => _cache[118] || (_cache[118] = [
                                      _createElementVNode("h4", null, "Sélection du montant de la modification à appliquer :", -1)
                                    ])),
                                    _: 1
                                  }))
                                : _createCommentVNode("", true),
                              (_ctx.staggeringModification !== 'equal')
                                ? (_openBlock(), _createBlock(_component_v_col, {
                                    key: 3,
                                    cols: "6",
                                    class: "d-flex mb-2"
                                  }, {
                                    default: _withCtx(() => [
                                      (_ctx.staggeringModification === 'percentage')
                                        ? (_openBlock(), _createBlock(_component_oss_text_field_filled, {
                                            key: 0,
                                            label: "%",
                                            "hide-details": "auto",
                                            modelValue: _ctx.staggeringPercentage,
                                            "onUpdate:modelValue": _cache[34] || (_cache[34] = ($event: any) => ((_ctx.staggeringPercentage) = $event))
                                          }, null, 8, ["modelValue"]))
                                        : (_ctx.staggeringModification === 'amount')
                                          ? (_openBlock(), _createBlock(_component_oss_text_field_filled, {
                                              key: 1,
                                              label: "€",
                                              "hide-details": "auto",
                                              modelValue: _ctx.staggeringAmount,
                                              "onUpdate:modelValue": _cache[35] || (_cache[35] = ($event: any) => ((_ctx.staggeringAmount) = $event))
                                            }, null, 8, ["modelValue"]))
                                          : _createCommentVNode("", true)
                                    ]),
                                    _: 1
                                  }))
                                : _createCommentVNode("", true),
                              (_ctx.staggeringModification !== 'equal')
                                ? (_openBlock(), _createBlock(_component_v_col, {
                                    key: 4,
                                    cols: "6",
                                    class: "d-flex mb-2"
                                  }, {
                                    default: _withCtx(() => _cache[119] || (_cache[119] = [
                                      _createElementVNode("h4", null, " Sélection du délai entre 2 applications de la modification ", -1)
                                    ])),
                                    _: 1
                                  }))
                                : _createCommentVNode("", true),
                              (_ctx.staggeringModification !== 'equal')
                                ? (_openBlock(), _createBlock(_component_v_col, {
                                    key: 5,
                                    cols: "6",
                                    class: "d-flex mb-2"
                                  }, {
                                    default: _withCtx(() => [
                                      _createVNode(_component_v_select_filled, {
                                        modelValue: _ctx.staggeringModificationFrequency,
                                        "onUpdate:modelValue": _cache[36] || (_cache[36] = ($event: any) => ((_ctx.staggeringModificationFrequency) = $event)),
                                        items: _ctx.staggeringModificationFrequencies,
                                        "item-value": "id",
                                        required: "",
                                        label: "Temps que met le client à vous payer",
                                        "hide-details": "auto",
                                        density: "compact",
                                        "item-title": (item) => item.name
                                      }, null, 8, ["modelValue", "items", "item-title"])
                                    ]),
                                    _: 1
                                  }))
                                : _createCommentVNode("", true)
                            ]),
                            _: 1
                          })
                        ]),
                        _: 1
                      })
                    ]),
                    _: 1
                  })
                ]),
                _: 1
              }, 8, ["modelValue"])
            ]),
            _: 1
          })
        ]),
        _: 1
      }, 8, ["modelValue", "onValid", "onClose", "valid-loading", "minWidth", "height", "valid-disabled"])
    ]),
    _: 1
  }, 8, ["modelValue"]))
}